define("SeasonalKeywords", [], function() { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 57);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_create__ = __webpack_require__(114);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return __WEBPACK_IMPORTED_MODULE_0__src_create__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_creator__ = __webpack_require__(21);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "creator", function() { return __WEBPACK_IMPORTED_MODULE_1__src_creator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_local__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "local", function() { return __WEBPACK_IMPORTED_MODULE_2__src_local__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_matcher__ = __webpack_require__(60);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_3__src_matcher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_mouse__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mouse", function() { return __WEBPACK_IMPORTED_MODULE_4__src_mouse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_namespace__ = __webpack_require__(31);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "namespace", function() { return __WEBPACK_IMPORTED_MODULE_5__src_namespace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_namespaces__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "namespaces", function() { return __WEBPACK_IMPORTED_MODULE_6__src_namespaces__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_point__ = __webpack_require__(22);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "clientPoint", function() { return __WEBPACK_IMPORTED_MODULE_7__src_point__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_select__ = __webpack_require__(58);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_8__src_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_selectAll__ = __webpack_require__(145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selectAll", function() { return __WEBPACK_IMPORTED_MODULE_9__src_selectAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_selection_index__ = __webpack_require__(3);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selection", function() { return __WEBPACK_IMPORTED_MODULE_10__src_selection_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_selector__ = __webpack_require__(33);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selector", function() { return __WEBPACK_IMPORTED_MODULE_11__src_selector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_selectorAll__ = __webpack_require__(59);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selectorAll", function() { return __WEBPACK_IMPORTED_MODULE_12__src_selectorAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_selection_style__ = __webpack_require__(63);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "style", function() { return __WEBPACK_IMPORTED_MODULE_13__src_selection_style__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_touch__ = __webpack_require__(146);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "touch", function() { return __WEBPACK_IMPORTED_MODULE_14__src_touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_touches__ = __webpack_require__(147);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "touches", function() { return __WEBPACK_IMPORTED_MODULE_15__src_touches__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_window__ = __webpack_require__(34);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "window", function() { return __WEBPACK_IMPORTED_MODULE_16__src_window__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_selection_on__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "event", function() { return __WEBPACK_IMPORTED_MODULE_17__src_selection_on__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "customEvent", function() { return __WEBPACK_IMPORTED_MODULE_17__src_selection_on__["a"]; });




















/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bisect__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisect", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisectRight", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisectLeft", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ascending__ = __webpack_require__(11);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ascending", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_bisector__ = __webpack_require__(65);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisector", function() { return __WEBPACK_IMPORTED_MODULE_2__src_bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cross__ = __webpack_require__(152);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cross", function() { return __WEBPACK_IMPORTED_MODULE_3__src_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_descending__ = __webpack_require__(153);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "descending", function() { return __WEBPACK_IMPORTED_MODULE_4__src_descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_deviation__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "deviation", function() { return __WEBPACK_IMPORTED_MODULE_5__src_deviation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_extent__ = __webpack_require__(69);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extent", function() { return __WEBPACK_IMPORTED_MODULE_6__src_extent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_histogram__ = __webpack_require__(154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "histogram", function() { return __WEBPACK_IMPORTED_MODULE_7__src_histogram__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__ = __webpack_require__(157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thresholdFreedmanDiaconis", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__ = __webpack_require__(158);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thresholdScott", function() { return __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__ = __webpack_require__(73);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thresholdSturges", function() { return __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_max__ = __webpack_require__(159);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_11__src_max__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_mean__ = __webpack_require__(160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mean", function() { return __WEBPACK_IMPORTED_MODULE_12__src_mean__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_median__ = __webpack_require__(161);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "median", function() { return __WEBPACK_IMPORTED_MODULE_13__src_median__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_merge__ = __webpack_require__(162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return __WEBPACK_IMPORTED_MODULE_14__src_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_min__ = __webpack_require__(74);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_15__src_min__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_pairs__ = __webpack_require__(66);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_16__src_pairs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_permute__ = __webpack_require__(163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "permute", function() { return __WEBPACK_IMPORTED_MODULE_17__src_permute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_quantile__ = __webpack_require__(37);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantile", function() { return __WEBPACK_IMPORTED_MODULE_18__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_range__ = __webpack_require__(71);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_19__src_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_scan__ = __webpack_require__(164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scan", function() { return __WEBPACK_IMPORTED_MODULE_20__src_scan__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_shuffle__ = __webpack_require__(165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_21__src_shuffle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_sum__ = __webpack_require__(166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sum", function() { return __WEBPACK_IMPORTED_MODULE_22__src_sum__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_ticks__ = __webpack_require__(72);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ticks", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tickIncrement", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tickStep", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_transpose__ = __webpack_require__(75);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_24__src_transpose__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_variance__ = __webpack_require__(68);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "variance", function() { return __WEBPACK_IMPORTED_MODULE_25__src_variance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_zip__ = __webpack_require__(167);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_26__src_zip__["a"]; });





























/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return root; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Selection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__select__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectAll__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enter__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exit__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__merge__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__order__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sort__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__call__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nodes__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__node__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__size__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__empty__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__each__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__attr__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__property__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__classed__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__text__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__html__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raise__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lower__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__append__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__insert__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__remove__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__clone__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__datum__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__on__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__dispatch__ = __webpack_require__(142);































var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: __WEBPACK_IMPORTED_MODULE_0__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_1__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_2__filter__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_3__data__["a" /* default */],
  enter: __WEBPACK_IMPORTED_MODULE_4__enter__["b" /* default */],
  exit: __WEBPACK_IMPORTED_MODULE_5__exit__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_6__merge__["a" /* default */],
  order: __WEBPACK_IMPORTED_MODULE_7__order__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_8__sort__["a" /* default */],
  call: __WEBPACK_IMPORTED_MODULE_9__call__["a" /* default */],
  nodes: __WEBPACK_IMPORTED_MODULE_10__nodes__["a" /* default */],
  node: __WEBPACK_IMPORTED_MODULE_11__node__["a" /* default */],
  size: __WEBPACK_IMPORTED_MODULE_12__size__["a" /* default */],
  empty: __WEBPACK_IMPORTED_MODULE_13__empty__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_14__each__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_15__attr__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_16__style__["a" /* default */],
  property: __WEBPACK_IMPORTED_MODULE_17__property__["a" /* default */],
  classed: __WEBPACK_IMPORTED_MODULE_18__classed__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_19__text__["a" /* default */],
  html: __WEBPACK_IMPORTED_MODULE_20__html__["a" /* default */],
  raise: __WEBPACK_IMPORTED_MODULE_21__raise__["a" /* default */],
  lower: __WEBPACK_IMPORTED_MODULE_22__lower__["a" /* default */],
  append: __WEBPACK_IMPORTED_MODULE_23__append__["a" /* default */],
  insert: __WEBPACK_IMPORTED_MODULE_24__insert__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_25__remove__["a" /* default */],
  clone: __WEBPACK_IMPORTED_MODULE_26__clone__["a" /* default */],
  datum: __WEBPACK_IMPORTED_MODULE_27__datum__["a" /* default */],
  on: __WEBPACK_IMPORTED_MODULE_28__on__["b" /* default */],
  dispatch: __WEBPACK_IMPORTED_MODULE_29__dispatch__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["b"] = (selection);


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CREATED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SCHEDULED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STARTING; });
/* unused harmony export STARTED */
/* unused harmony export RUNNING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENDED; });
/* harmony export (immutable) */ __webpack_exports__["g"] = init;
/* harmony export (immutable) */ __webpack_exports__["h"] = set;
/* harmony export (immutable) */ __webpack_exports__["f"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_timer__ = __webpack_require__(110);



var emptyOn = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["a" /* dispatch */])("start", "end", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

/* harmony default export */ __webpack_exports__["e"] = (function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
});

function init(node, id) {
  var schedule = get(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function set(node, id) {
  var schedule = get(node, id);
  if (schedule.state > STARTING) throw new Error("too late; already started");
  return schedule;
}

function get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["c" /* timer */])(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["b" /* timeout */])(start);

      // Interrupt the active transition, if any.
      // Dispatch the interrupt event.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    Object(__WEBPACK_IMPORTED_MODULE_1_d3_timer__["b" /* timeout */])(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(null, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Transition;
/* harmony export (immutable) */ __webpack_exports__["b"] = transition;
/* harmony export (immutable) */ __webpack_exports__["c"] = newId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attr__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attrTween__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__delay__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__duration__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ease__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filter__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__merge__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__on__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__remove__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__select__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectAll__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selection__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styleTween__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__text__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__transition__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tween__ = __webpack_require__(30);



















var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition(name) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["selection"])().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["selection"].prototype;

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: __WEBPACK_IMPORTED_MODULE_10__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_11__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_6__filter__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_7__merge__["a" /* default */],
  selection: __WEBPACK_IMPORTED_MODULE_12__selection__["a" /* default */],
  transition: __WEBPACK_IMPORTED_MODULE_16__transition__["a" /* default */],
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: __WEBPACK_IMPORTED_MODULE_8__on__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_1__attr__["a" /* default */],
  attrTween: __WEBPACK_IMPORTED_MODULE_2__attrTween__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_13__style__["a" /* default */],
  styleTween: __WEBPACK_IMPORTED_MODULE_14__styleTween__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_15__text__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_9__remove__["a" /* default */],
  tween: __WEBPACK_IMPORTED_MODULE_17__tween__["a" /* default */],
  delay: __WEBPACK_IMPORTED_MODULE_3__delay__["a" /* default */],
  duration: __WEBPACK_IMPORTED_MODULE_4__duration__["a" /* default */],
  ease: __WEBPACK_IMPORTED_MODULE_5__ease__["a" /* default */]
};


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(40);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolate", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateArray", function() { return __WEBPACK_IMPORTED_MODULE_1__src_array__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(43);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasis", function() { return __WEBPACK_IMPORTED_MODULE_2__src_basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(79);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(82);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateDate", function() { return __WEBPACK_IMPORTED_MODULE_4__src_date__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateNumber", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(83);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateObject", function() { return __WEBPACK_IMPORTED_MODULE_6__src_object__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRound", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(84);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateString", function() { return __WEBPACK_IMPORTED_MODULE_8__src_string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformCss", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformSvg", function() { return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateZoom", function() { return __WEBPACK_IMPORTED_MODULE_10__src_zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(78);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgb", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasis", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHsl", function() { return __WEBPACK_IMPORTED_MODULE_12__src_hsl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHslLong", function() { return __WEBPACK_IMPORTED_MODULE_12__src_hsl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(184);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateLab", function() { return __WEBPACK_IMPORTED_MODULE_13__src_lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(185);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHcl", function() { return __WEBPACK_IMPORTED_MODULE_14__src_hcl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHclLong", function() { return __WEBPACK_IMPORTED_MODULE_14__src_hcl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelix", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixLong", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_piecewise__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "piecewise", function() { return __WEBPACK_IMPORTED_MODULE_16__src_piecewise__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_quantize__ = __webpack_require__(188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantize", function() { return __WEBPACK_IMPORTED_MODULE_17__src_quantize__["a"]; });




















/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(41);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(176);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
/* unused harmony reexport lch */
/* unused harmony reexport gray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(189);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ticks"])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickIncrement"])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickIncrement"])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickIncrement"])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateNumber"]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 13 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(150);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(80);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_path__ = __webpack_require__(224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_path__["a"]; });



/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__namespaces__ = __webpack_require__(32);



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */] && document.documentElement.namespaceURI === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */]
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
});


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
});


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(85);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolate"],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateRound"], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(45);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tweenValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(4);


function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
});

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(node, id).value[name];
  };
}


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespaces__ = __webpack_require__(32);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */].hasOwnProperty(prefix) ? {space: __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */][prefix], local: name} : name;
});


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return xhtml; });
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ __webpack_exports__["a"] = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function none() {}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
});


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
});


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return event; });
/* harmony export (immutable) */ __webpack_exports__["a"] = customEvent;
var filterEvents = {};

var event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = event; // Events can be reentrant (e.g., focus).
    event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      event = event0;
    }
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ __webpack_exports__["b"] = (function(typename, value, capture) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
});

function customEvent(event1, listener, that, args) {
  var event0 = event;
  event1.sourceEvent = event;
  event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    event = event0;
  }
}


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_on__ = __webpack_require__(35);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var current = __WEBPACK_IMPORTED_MODULE_0__selection_on__["c" /* event */], source;
  while (source = current.sourceEvent) current = source;
  return current;
});


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(15);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleBand", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePoint", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleIdentity", function() { return __WEBPACK_IMPORTED_MODULE_1__src_identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(12);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLinear", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(200);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLog", function() { return __WEBPACK_IMPORTED_MODULE_3__src_log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(76);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleOrdinal", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleImplicit", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(201);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePow", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSqrt", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(202);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantile", function() { return __WEBPACK_IMPORTED_MODULE_6__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantize", function() { return __WEBPACK_IMPORTED_MODULE_7__src_quantize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleThreshold", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(91);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleTime", function() { return __WEBPACK_IMPORTED_MODULE_9__src_time__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(220);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleUtc", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_sequential__ = __webpack_require__(221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequential", function() { return __WEBPACK_IMPORTED_MODULE_11__src_sequential__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_diverging__ = __webpack_require__(222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDiverging", function() { return __WEBPACK_IMPORTED_MODULE_12__src_diverging__["a"]; });



























/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(80);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(42);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: function() {
    return this.rgb().hex();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: function() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_interval__ = __webpack_require__(0);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__ = __webpack_require__(205);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_second__ = __webpack_require__(206);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_minute__ = __webpack_require__(207);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_minute__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_hour__ = __webpack_require__(208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__src_hour__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_day__ = __webpack_require__(209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_week__ = __webpack_require__(210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["c"]; });
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_month__ = __webpack_require__(211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__src_month__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_year__ = __webpack_require__(212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__ = __webpack_require__(213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__ = __webpack_require__(214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__ = __webpack_require__(215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__ = __webpack_require__(216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["c"]; });
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__ = __webpack_require__(217);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__ = __webpack_require__(218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(93);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_arc__ = __webpack_require__(223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arc", function() { return __WEBPACK_IMPORTED_MODULE_0__src_arc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_area__ = __webpack_require__(95);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "area", function() { return __WEBPACK_IMPORTED_MODULE_1__src_area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_line__ = __webpack_require__(49);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "line", function() { return __WEBPACK_IMPORTED_MODULE_2__src_line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pie__ = __webpack_require__(225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pie", function() { return __WEBPACK_IMPORTED_MODULE_3__src_pie__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__ = __webpack_require__(228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "areaRadial", function() { return __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialArea", function() { return __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lineRadial", function() { return __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialLine", function() { return __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__ = __webpack_require__(98);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pointRadial", function() { return __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_link_index__ = __webpack_require__(229);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkVertical", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkRadial", function() { return __WEBPACK_IMPORTED_MODULE_7__src_link_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_symbol__ = __webpack_require__(230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbol", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbols", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__ = __webpack_require__(100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__ = __webpack_require__(101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCross", function() { return __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__ = __webpack_require__(102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolDiamond", function() { return __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__ = __webpack_require__(104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolSquare", function() { return __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__ = __webpack_require__(103);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolStar", function() { return __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__ = __webpack_require__(105);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolTriangle", function() { return __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__ = __webpack_require__(106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolWye", function() { return __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__ = __webpack_require__(231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__ = __webpack_require__(232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisOpen", function() { return __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__ = __webpack_require__(28);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasis", function() { return __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__ = __webpack_require__(233);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBundle", function() { return __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__ = __webpack_require__(107);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalClosed", function() { return __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__ = __webpack_require__(108);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalOpen", function() { return __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinal", function() { return __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__ = __webpack_require__(234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomClosed", function() { return __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__ = __webpack_require__(235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomOpen", function() { return __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__ = __webpack_require__(51);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRom", function() { return __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__ = __webpack_require__(236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinearClosed", function() { return __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__ = __webpack_require__(26);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinear", function() { return __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__ = __webpack_require__(237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneX", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneY", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__ = __webpack_require__(238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveNatural", function() { return __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_curve_step__ = __webpack_require__(239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStep", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepAfter", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepBefore", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_stack__ = __webpack_require__(240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stack", function() { return __WEBPACK_IMPORTED_MODULE_31__src_stack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__ = __webpack_require__(241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetExpand", function() { return __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__ = __webpack_require__(242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetDiverging", function() { return __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_offset_none__ = __webpack_require__(19);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetNone", function() { return __WEBPACK_IMPORTED_MODULE_34__src_offset_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__ = __webpack_require__(243);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetSilhouette", function() { return __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__ = __webpack_require__(244);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetWiggle", function() { return __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__ = __webpack_require__(52);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderAscending", function() { return __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_order_descending__ = __webpack_require__(245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderDescending", function() { return __WEBPACK_IMPORTED_MODULE_38__src_order_descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__ = __webpack_require__(246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderInsideOut", function() { return __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__src_order_none__ = __webpack_require__(20);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderNone", function() { return __WEBPACK_IMPORTED_MODULE_40__src_order_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__ = __webpack_require__(247);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderReverse", function() { return __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__["a"]; });




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!









































/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(50);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(29);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var sums = series.map(sum);
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_selection_index__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_transition_index__ = __webpack_require__(6);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "transition", function() { return __WEBPACK_IMPORTED_MODULE_1__src_transition_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_active__ = __webpack_require__(282);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "active", function() { return __WEBPACK_IMPORTED_MODULE_2__src_active__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_interrupt__ = __webpack_require__(109);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interrupt", function() { return __WEBPACK_IMPORTED_MODULE_3__src_interrupt__["a"]; });






/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = now;
/* harmony export (immutable) */ __webpack_exports__["a"] = Timer;
/* harmony export (immutable) */ __webpack_exports__["c"] = timer;
/* unused harmony export timerFlush */
var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getKeywordId(keyword) {
    return getQueryId(keyword);
}
exports.getKeywordId = getKeywordId;
function getQueryId(query) {
    return query.terms;
}
exports.getQueryId = getQueryId;
function getIndexOfKeyword(keyword, keywordsList) {
    return getIndexOfQuery(keyword, keywordsList);
}
exports.getIndexOfKeyword = getIndexOfKeyword;
function getIndexOfQuery(query, queriesList) {
    for (var index = 0; index < queriesList.length; index++) {
        if (getQueryId(queriesList[index]) === getQueryId(query)) {
            return index;
        }
    }
    return -1;
}
exports.getIndexOfQuery = getIndexOfQuery;
function sortKeywords(keywordsList) {
    sortQueries(keywordsList);
}
exports.sortKeywords = sortKeywords;
function sortQueries(queriesList) {
    queriesList.sort((function (d1, d2) {
        if (d1.queryCount === d2.queryCount) {
            return d1.terms.localeCompare(d2.terms);
        }
        return (d2.queryCount - d1.queryCount);
    }));
}
exports.sortQueries = sortQueries;
function getNextSelectionOrderAvailable(selectedKeywordsList, maxKeywordsSelected) {
    var _loop_1 = function (selectionOrder) {
        if (!selectedKeywordsList.some(function (d) { return (d.selectionOrder === selectionOrder); })) {
            return { value: selectionOrder };
        }
    };
    for (var selectionOrder = 1; selectionOrder <= maxKeywordsSelected; selectionOrder++) {
        var state_1 = _loop_1(selectionOrder);
        if (typeof state_1 === "object")
            return state_1.value;
    }
}
exports.getNextSelectionOrderAvailable = getNextSelectionOrderAvailable;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DetailsComponentEnum;
(function (DetailsComponentEnum) {
    DetailsComponentEnum["PERIOD_SELECTOR"] = "period-selector";
    DetailsComponentEnum["KEYWORDS_DETAILS"] = "keywords-details";
})(DetailsComponentEnum = exports.DetailsComponentEnum || (exports.DetailsComponentEnum = {}));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3_selection_1 = __webpack_require__(1);
__webpack_require__(148);
var keywords_selector_component_1 = __webpack_require__(151);
var selected_keywords_container_component_1 = __webpack_require__(285);
var details_component_enum_1 = __webpack_require__(56);
exports.DetailsComponentEnum = details_component_enum_1.DetailsComponentEnum;
var performance_indicator_enum_1 = __webpack_require__(113);
exports.PerformanceIndicatorEnum = performance_indicator_enum_1.PerformanceIndicatorEnum;
var data_utils_1 = __webpack_require__(55);
var Visualization = (function () {
    function Visualization(visualizationHtmlElement, size, config, data) {
        this.visualizationHtmlElement = visualizationHtmlElement;
        this.size = size;
        this.config = {
            transitionsDurationInMillis: 500,
            maxKeywordsSelected: 2,
            selectedPerformanceIndicator: performance_indicator_enum_1.PerformanceIndicatorEnum.QUERY_COUNT,
            selectedPeriod: {}
        };
        this.data = {
            keywords: [],
            selectedKeywords: []
        };
        this.visualizationTemplate = "\n    <div class=\"seasonal-keywords__keywords-selector\"></div>\n    <div class=\"seasonal-keywords__selected-keywords-container\"></div>\n  ";
        this.keywordsSelectorHeight = 90;
        if (!!config && !!config.maxKeywordsSelected) {
            config.maxKeywordsSelected = Math.min(config.maxKeywordsSelected, 2);
        }
        this.config = Object.assign(this.config, config);
        this.data = Object.assign(this.data, data);
        this.initializeVisualization();
    }
    Visualization.checkTouchSupport = function () {
        return ((typeof window !== 'undefined') && ('ontouchstart' in window));
    };
    Visualization.prototype.destroyVisualization = function () {
        window.removeEventListener('resize', this.onWindowResize);
    };
    Visualization.prototype.getConfig = function () {
        return {
            maxKeywordsSelected: this.config.maxKeywordsSelected,
            selectedPerformanceIndicator: this.config.selectedPerformanceIndicator,
            selectedPeriod: this.config.selectedPeriod
        };
    };
    Visualization.prototype.setConfig = function (config) {
        delete config.maxKeywordsSelected;
        this.config = Object.assign(this.config, config);
        this.keywordsSelectorComponent.setConfig(this.config);
        this.selectedKeywordsContainerComponent.setConfig(this.config);
    };
    Visualization.prototype.getData = function () {
        return this.data;
    };
    Visualization.prototype.setData = function (data, clearKeywordsSelection) {
        if (clearKeywordsSelection === void 0) { clearKeywordsSelection = false; }
        this.data = Object.assign(this.data, __assign({}, data, { selectedKeywords: (clearKeywordsSelection ? [] : (data.selectedKeywords || this.data.selectedKeywords).slice(0, this.config.maxKeywordsSelected)) }));
        this.copyRelatedQueriesFromKeywordsDataSetToSelectedKeywords();
        this.keywordsSelectorComponent.setData(this.data);
        this.selectedKeywordsContainerComponent.setData(this.data);
        if (clearKeywordsSelection) {
            this.setConfig({
                selectedPeriod: {}
            });
        }
    };
    Visualization.prototype.resize = function (size) {
        this.size = size;
        this.keywordsSelectorComponent.resize({
            width: this.size.width,
            height: this.keywordsSelectorHeight
        });
        this.selectedKeywordsContainerComponent.resize({
            width: this.size.width,
            height: (this.size.height - this.keywordsSelectorHeight)
        });
    };
    Visualization.prototype.onKeywordSelect = function (keyword) { };
    Visualization.prototype.initializeVisualization = function () {
        var _this = this;
        this.visualizationHtmlElement.innerHTML = this.visualizationTemplate;
        this.visualizationElement = d3_selection_1.select(this.visualizationHtmlElement)
            .classed('seasonal-keywords', true);
        this.initializeKeywordsSelectorComponent();
        this.initializeSelectedKeywordsContainerComponent();
        this.onWindowResize = function () {
            _this.resize({
                width: _this.getVisualizationElementWidth(),
                height: _this.getVisualizationElementHeight()
            });
        };
        window.addEventListener('resize', this.onWindowResize);
    };
    Visualization.prototype.onWindowResize = function () { };
    Visualization.prototype.getVisualizationElementWidth = function () {
        return this.visualizationElement.node().getBoundingClientRect().width;
    };
    Visualization.prototype.getVisualizationElementHeight = function () {
        return this.visualizationElement.node().getBoundingClientRect().height;
    };
    Visualization.prototype.initializeKeywordsSelectorComponent = function () {
        var _this = this;
        this.keywordsSelectorElement = this.visualizationElement
            .select('.seasonal-keywords__keywords-selector');
        this.keywordsSelectorComponent = new keywords_selector_component_1.KeywordsSelectorComponent(this.keywordsSelectorElement.node(), {
            width: this.getVisualizationElementWidth(),
            height: this.keywordsSelectorHeight
        }, this.config, this.data);
        this.keywordsSelectorComponent.onKeywordMouseOver = function (keyword) {
            _this.onKeywordMouseOver(keyword);
        };
        this.keywordsSelectorComponent.onKeywordMouseOut = function () {
            _this.onKeywordMouseOut();
        };
        this.keywordsSelectorComponent.onKeywordClick = function (keyword) {
            _this.onKeywordClick(keyword);
            if (!keyword.relatedQueries) {
                _this.onKeywordSelect(keyword);
            }
        };
    };
    Visualization.prototype.onKeywordMouseOver = function (keyword) {
        if (Visualization.checkTouchSupport()) {
            return;
        }
        this.keywordsSelectorComponent.setHoveredKeyword(keyword);
    };
    Visualization.prototype.onKeywordMouseOut = function () {
        if (Visualization.checkTouchSupport()) {
            return;
        }
        this.keywordsSelectorComponent.setHoveredKeyword();
    };
    Visualization.prototype.onKeywordClick = function (keyword) {
        if (data_utils_1.getIndexOfKeyword(keyword, this.data.selectedKeywords) < 0) {
            this.onKeywordMouseOut();
            var selectedKeyword = __assign({}, keyword, { selectionOrder: data_utils_1.getNextSelectionOrderAvailable(this.data.selectedKeywords, this.config.maxKeywordsSelected) });
            this.setData({
                selectedKeywords: this.data.selectedKeywords.concat([selectedKeyword])
            });
        }
        else {
            this.onKeywordMouseOver(keyword);
            this.setData({
                selectedKeywords: this.data.selectedKeywords.filter(function (d) { return (data_utils_1.getKeywordId(d) !== data_utils_1.getKeywordId(keyword)); })
            });
        }
    };
    Visualization.prototype.initializeSelectedKeywordsContainerComponent = function () {
        var _this = this;
        this.selectedKeywordsContainerElement = this.visualizationElement
            .select('.seasonal-keywords__selected-keywords-container');
        this.selectedKeywordsContainerComponent = new selected_keywords_container_component_1.SelectedKeywordsContainerComponent(this.selectedKeywordsContainerElement.node(), {
            width: this.getVisualizationElementWidth(),
            height: (this.getVisualizationElementHeight() - this.keywordsSelectorHeight)
        }, this.config, this.data);
        this.selectedKeywordsContainerComponent.onPeriodSelected = function (period) {
            _this.onPeriodSelected(period);
        };
        this.selectedKeywordsContainerComponent.onDetailsComponentExpanderControlClick = function (detailsComponent) {
            _this.onDetailsComponentExpanderControlClick(detailsComponent);
        };
    };
    Visualization.prototype.onPeriodSelected = function (period) {
        this.setConfig({
            selectedPeriod: period
        });
    };
    Visualization.prototype.onDetailsComponentExpanderControlClick = function (detailsComponent) {
        if (detailsComponent === this.config.expandedDetailsComponent) {
            this.setConfig({
                expandedDetailsComponent: undefined
            });
        }
        else {
            this.setConfig({
                expandedDetailsComponent: detailsComponent
            });
        }
    };
    Visualization.prototype.copyRelatedQueriesFromKeywordsDataSetToSelectedKeywords = function () {
        var _this = this;
        this.data.selectedKeywords.forEach(function (selectedKeyword) {
            var keywordDataSet = _this.data.keywords
                .find(function (keywordDs) { return keywordDs.terms === selectedKeyword.terms; });
            if (!!keywordDataSet) {
                selectedKeyword.relatedQueries = keywordDataSet.relatedQueries;
            }
        });
    };
    return Visualization;
}());
exports.Visualization = Visualization;


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[document.querySelector(selector)]], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[selector]], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function empty() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
});


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (matcher);


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = EnterNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["b"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._enter || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(update) {
  return new Array(update.length);
});


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = styleValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(34);


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
});

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node).getComputedStyle(node, null).getPropertyValue(name);
}


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bisectRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bisectLeft; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(65);



var ascendingBisect = Object(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["c"] = (bisectRight);


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(11);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = pair;
/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(68);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = Object(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(15);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(74);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return implicit; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(7);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rgbBasis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rgbBasisClosed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(16);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(43);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(23);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(190);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(87);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(88);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTrim__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatTypes__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__identity__ = __webpack_require__(196);









var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_7__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? Object(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_7__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!__WEBPACK_IMPORTED_MODULE_5__formatTypes__["a" /* default */][type]) precision == null && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_5__formatTypes__["a" /* default */][type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = Object(__WEBPACK_IMPORTED_MODULE_4__formatTrim__["a" /* default */])(value);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  this.fill = match[1] || " ";
  this.align = match[2] || ">";
  this.sign = match[3] || "-";
  this.symbol = match[4] || "";
  this.zero = !!match[5];
  this.width = match[6] && +match[6];
  this.comma = !!match[7];
  this.precision = match[8] && +match[8].slice(1);
  this.trim = !!match[9];
  this.type = match[10] || "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(45);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(90);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateNumber"]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisector"])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["k" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["a" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(47);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(93);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__ = __webpack_require__(94);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_isoParse__ = __webpack_require__(219);
/* unused harmony reexport isoParse */






/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(46);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newYear(d.y)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = newDate(newYear(d.y)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* timeSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["s" /* utcSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(47);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["b" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(50);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["b"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(26);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lineRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(49);



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return lineRadial(Object(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]));
});


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */]);
  }
});


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(18);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(29);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__cardinal__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(29);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__cardinal__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_schedule__ = __webpack_require__(4);


/* harmony default export */ __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["d" /* STARTING */] && schedule.state < __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["b" /* ENDING */];
    schedule.state = __WEBPACK_IMPORTED_MODULE_0__transition_schedule__["a" /* ENDED */];
    schedule.timer.stop();
    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
});


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_timer__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_timer__["c"]; });
/* unused harmony reexport timerFlush */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_timeout__ = __webpack_require__(252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_timeout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_interval__ = __webpack_require__(253);
/* unused harmony reexport interval */







/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var c;
  return (typeof b === "number" ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateNumber"]
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateRgb"]
      : (c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateRgb"])
      : __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateString"])(a, b);
});


/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PerformanceIndicatorEnum;
(function (PerformanceIndicatorEnum) {
    PerformanceIndicatorEnum[PerformanceIndicatorEnum["QUERY_COUNT"] = 0] = "QUERY_COUNT";
    PerformanceIndicatorEnum[PerformanceIndicatorEnum["CLICK_RATIO"] = 1] = "CLICK_RATIO";
    PerformanceIndicatorEnum[PerformanceIndicatorEnum["ADD2CART_RATIO"] = 2] = "ADD2CART_RATIO";
    PerformanceIndicatorEnum[PerformanceIndicatorEnum["NO_RESULTS_COUNT"] = 3] = "NO_RESULTS_COUNT";
})(PerformanceIndicatorEnum = exports.PerformanceIndicatorEnum || (exports.PerformanceIndicatorEnum = {}));


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__select__ = __webpack_require__(58);



/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__select__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name).call(document.documentElement));
});


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(33);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectorAll__ = __webpack_require__(59);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_1__selectorAll__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, parents);
});


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(60);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" /* default */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enter__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(119);




var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["a" /* EnterNode */](parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
});


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._exit || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = (function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](merges, this._parents);
});


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
});


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](sortgroups, this._parents).order();
});

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
});


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
});


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
});


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
});


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return !this.node();
});


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
});


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(31);


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
});


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
});


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
});


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
});


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
});


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(raise);
});


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(lower);
});


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(21);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
});


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(33);



function constantNull() {
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, before) {
  var create = typeof name === "function" ? name : Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name),
      select = before == null ? constantNull : typeof before === "function" ? before : Object(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
});


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(remove);
});


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function selection_cloneShallow() {
  return this.parentNode.insertBefore(this.cloneNode(false), this.nextSibling);
}

function selection_cloneDeep() {
  return this.parentNode.insertBefore(this.cloneNode(true), this.nextSibling);
}

/* harmony default export */ __webpack_exports__["a"] = (function(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
});


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
});


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(34);


function dispatchEvent(node, type, params) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
});


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = local;
var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(22);



/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  var event = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])();
  if (event.changedTouches) event = event.changedTouches[0];
  return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, event);
});


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([document.querySelectorAll(selector)], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([selector == null ? [] : selector], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(22);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touch);
    }
  }

  return null;
});


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(22);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches) {
  if (touches == null) touches = Object(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = Object(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touches[i]);
  }

  return points;
});


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(149);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(14)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/resolve-url-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?sourceMap!./visualization.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/resolve-url-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?sourceMap!./visualization.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(13)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 150 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var d3_array_1 = __webpack_require__(2);
var d3_scale_1 = __webpack_require__(38);
var d3_selection_1 = __webpack_require__(1);
var d3_shape_1 = __webpack_require__(48);
__webpack_require__(53);
var data_utils_1 = __webpack_require__(55);
__webpack_require__(283);
var KeywordsSelectorComponent = (function () {
    function KeywordsSelectorComponent(componentHtmlElement, size, config, data) {
        this.componentHtmlElement = componentHtmlElement;
        this.size = size;
        this.config = config;
        this.data = data;
        this.componentTemplate = "\n    <svg class=\"keywords-selector__keywords-selector-list\" shape-rendering=\"geometricPrecision\"></svg>\n  ";
        this.keywordsSelectorList = [];
        this.keywordsDistributionDatetimeScale = d3_scale_1.scaleLinear();
        this.keywordsDistributionValueScale = d3_scale_1.scaleLinear();
        this.keywordsSelectorListPaddingBottom = 5;
        this.keywordWidth = 144;
        this.keywordMargin = 5;
        this.keywordPadding = 3;
        this.containerRadius = 4;
        this.keywordTermTextHeight = 22;
        this.keywordValueTextHeight = 16;
        this.initializeComponent();
    }
    KeywordsSelectorComponent.prototype.setConfig = function (config) {
        this.config = config;
    };
    KeywordsSelectorComponent.prototype.setData = function (data) {
        this.data = data;
        this.keywordsSelectorList = this.getKeywordsSelectorList();
        if (!this.hoveredKeyword || (data_utils_1.getIndexOfKeyword(this.hoveredKeyword, this.keywordsSelectorList) < 0)) {
            this.setHoveredKeyword();
        }
        this.setChartsScalesDomain();
        this.renderKeywordsSelectorList();
    };
    KeywordsSelectorComponent.prototype.resize = function (size) {
        this.size = size;
    };
    KeywordsSelectorComponent.prototype.onKeywordMouseOver = function (keyword) { };
    KeywordsSelectorComponent.prototype.onKeywordMouseOut = function () { };
    KeywordsSelectorComponent.prototype.onKeywordClick = function (keyword) { };
    KeywordsSelectorComponent.prototype.setHoveredKeyword = function (keyword) {
        var _this = this;
        this.hoveredKeyword = keyword;
        this.keywordsSelectorListElement
            .selectAll('.keywords-selector-serie')
            .attr('class', function (d) { return _this.getKeywordsSelectorListSerieClass(d); });
        this.keywordsSelectorListElement
            .selectAll('.keywords-selector-serie__text--unselect')
            .style('visibility', function (d) { return _this.getKeywordUnselectTextVisibility(d); });
    };
    KeywordsSelectorComponent.prototype.initializeComponent = function () {
        this.componentHtmlElement.innerHTML += this.componentTemplate;
        this.componentElement = d3_selection_1.select(this.componentHtmlElement)
            .classed('keywords-selector', true);
        this.keywordsSelectorListElement = this.componentElement
            .select('.keywords-selector__keywords-selector-list')
            .attr('height', this.size.height);
        this.keywordsSelectorList = this.getKeywordsSelectorList();
        this.setChartsScalesRange();
        if (this.keywordsSelectorList.length > 0) {
            this.setChartsScalesDomain();
            this.renderKeywordsSelectorList();
        }
    };
    KeywordsSelectorComponent.prototype.setChartsScalesRange = function () {
        this.keywordsDistributionDatetimeScale
            .range([0, (this.keywordWidth - (2 * (this.keywordMargin + this.keywordPadding)))]);
        var keywordContentHeight = ((this.size.height - this.keywordsSelectorListPaddingBottom) -
            (2 * (this.keywordMargin + this.keywordPadding)));
        this.keywordsDistributionValueScale
            .range([keywordContentHeight, (this.keywordTermTextHeight + +(this.keywordValueTextHeight / 2))]);
    };
    KeywordsSelectorComponent.prototype.renderKeywordsSelectorList = function () {
        this.keywordsSelectorListElement
            .transition().duration(this.config.transitionsDurationInMillis)
            .style('width', (this.keywordsSelectorList.length * this.keywordWidth));
        var series = this.keywordsSelectorListElement
            .selectAll('.keywords-selector-serie')
            .data(this.keywordsSelectorList, data_utils_1.getKeywordId);
        this.removeKeywordsSelectorListSeries(series);
        this.updateKeywordsSelectorListSeries(series);
        this.enterKeywordsSelectorListSeries(series);
    };
    KeywordsSelectorComponent.prototype.removeKeywordsSelectorListSeries = function (series) {
        var exitSeries = series.exit();
        exitSeries
            .transition().duration(this.config.transitionsDurationInMillis)
            .style('opacity', 0);
        exitSeries
            .style('pointer-events', 'none')
            .transition().delay(this.config.transitionsDurationInMillis)
            .remove();
    };
    KeywordsSelectorComponent.prototype.updateKeywordsSelectorListSeries = function (series) {
        var _this = this;
        series
            .attr('class', function (d) { return _this.getKeywordsSelectorListSerieClass(d); })
            .style('pointer-events', 'auto')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('transform', function (d) { return "translate(" + _this.getKeywordsSelectorListSeriePositionX(d) + ", 0)"; })
            .style('opacity', 1);
        series
            .select('.keywords-selector-serie__distribution')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('d', function (d) { return _this.getKeywordDistributionCommands(d); });
        series
            .select('.keywords-selector-serie__text--value')
            .text(function (d) { return _this.getKeywordValueText(d); });
        series
            .select('.keywords-selector-serie__text--unselect')
            .style('visibility', function (d) { return _this.getKeywordUnselectTextVisibility(d); });
    };
    KeywordsSelectorComponent.prototype.getKeywordsSelectorListSerieClass = function (keyword) {
        var baseSerieClass = 'keywords-selector-serie';
        var serieClass = baseSerieClass;
        if (this.isKeywordHovered(keyword)) {
            serieClass += " " + baseSerieClass + "--hovered";
        }
        else {
            if (!!this.hoveredKeyword) {
                serieClass += " " + baseSerieClass + "--not-hovered";
            }
        }
        if (this.isKeywordSelected(keyword)) {
            serieClass += " " + baseSerieClass + "--selected";
            if (!!keyword.selectionOrder) {
                serieClass += " " + baseSerieClass + "--selected-" + keyword.selectionOrder;
            }
        }
        else {
            if (this.data.selectedKeywords.length < this.config.maxKeywordsSelected) {
                var nextSelectionOrderAvailable = data_utils_1.getNextSelectionOrderAvailable(this.data.selectedKeywords, this.config.maxKeywordsSelected);
                serieClass += " " + baseSerieClass + "--enabled  " + baseSerieClass + "--enabled-" + nextSelectionOrderAvailable;
            }
            else {
                serieClass += " " + baseSerieClass + "--disabled";
            }
        }
        return serieClass;
    };
    KeywordsSelectorComponent.prototype.isKeywordHovered = function (keyword) {
        return (!!this.hoveredKeyword && (data_utils_1.getKeywordId(keyword) === data_utils_1.getKeywordId(this.hoveredKeyword)));
    };
    KeywordsSelectorComponent.prototype.isKeywordSelected = function (keyword) {
        return (data_utils_1.getIndexOfKeyword(keyword, this.data.selectedKeywords) >= 0);
    };
    KeywordsSelectorComponent.prototype.getKeywordsSelectorListSeriePositionX = function (keyword) {
        return (data_utils_1.getIndexOfKeyword(keyword, this.keywordsSelectorList) * this.keywordWidth);
    };
    KeywordsSelectorComponent.prototype.getKeywordDistributionCommands = function (keyword) {
        var _this = this;
        var maxValueOfDistribution = d3_array_1.max(keyword.distribution, function (d) { return d.queryCount; });
        if (maxValueOfDistribution > 0) {
            var distributionArea = d3_shape_1.area()
                .curve(d3_shape_1.curveMonotoneX)
                .x(function (d) { return _this.keywordsDistributionDatetimeScale(d.datetime); })
                .y0(this.keywordsDistributionValueScale.range()[0])
                .y1(function (d) { return _this.keywordsDistributionValueScale(d.queryCount / maxValueOfDistribution); });
            return distributionArea(keyword.distribution);
        }
    };
    KeywordsSelectorComponent.prototype.getKeywordValueText = function (keyword) {
        return keyword.queryCount.toLocaleString() + " queries";
    };
    KeywordsSelectorComponent.prototype.getKeywordUnselectTextVisibility = function (keyword) {
        if (this.isKeywordHovered(keyword) && this.isKeywordSelected(keyword)) {
            return 'visible';
        }
        return 'hidden';
    };
    KeywordsSelectorComponent.prototype.enterKeywordsSelectorListSeries = function (series) {
        var _this = this;
        var enterSeries = series.enter()
            .append('g')
            .attr('class', function (d) { return _this.getKeywordsSelectorListSerieClass(d); })
            .on('mouseover', function (d) { return _this.onKeywordMouseOver(d); })
            .on('mouseout', function () { return _this.onKeywordMouseOut(); })
            .on('click', function (d) { return _this.onKeywordClick(d); });
        enterSeries
            .attr('transform', "translate(" + -this.keywordWidth + ", 0)")
            .style('opacity', 0)
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('transform', function (d) { return "translate(" + _this.getKeywordsSelectorListSeriePositionX(d) + ", 0)"; })
            .style('opacity', 1);
        var keywordContent = enterSeries
            .append('g')
            .attr('transform', "translate(" + (this.keywordMargin + this.keywordPadding) + ", " + (this.keywordMargin + this.keywordPadding) + ")");
        keywordContent
            .append('path')
            .attr('class', 'keywords-selector-serie__distribution')
            .attr('d', function (d) { return _this.getKeywordDistributionCommands(d); });
        var keywordTextPadding = 4;
        keywordContent
            .append('text')
            .attr('class', 'keywords-selector-serie__text keywords-selector-serie__text--term')
            .attr('y', (this.keywordTermTextHeight / 2))
            .attr('dx', keywordTextPadding)
            .attr('dy', (this.keywordTermTextHeight / 4))
            .text(function (d) { return d.terms; });
        keywordContent
            .append('text')
            .attr('class', 'keywords-selector-serie__text keywords-selector-serie__text--value')
            .attr('y', (this.keywordTermTextHeight + (this.keywordValueTextHeight / 2)))
            .attr('dx', keywordTextPadding)
            .attr('dy', (this.keywordValueTextHeight / 4))
            .text(function (d) { return _this.getKeywordValueText(d); });
        enterSeries
            .append('rect')
            .attr('class', 'keywords-selector-serie__container')
            .attr('x', this.keywordMargin)
            .attr('y', this.keywordMargin)
            .attr('rx', this.containerRadius)
            .attr('ry', this.containerRadius)
            .attr('width', (this.keywordWidth - (this.keywordMargin * 2)))
            .attr('height', ((this.size.height - this.keywordsSelectorListPaddingBottom) - (this.keywordMargin * 2)));
        var keywordUnselectTextHeight = 20;
        enterSeries
            .append('text')
            .attr('class', 'keywords-selector-serie__text keywords-selector-serie__text--unselect')
            .attr('x', (this.keywordWidth / 2))
            .attr('y', ((this.size.height - this.keywordsSelectorListPaddingBottom) / 2))
            .attr('dy', (keywordUnselectTextHeight / 4))
            .style('visibility', function (d) { return _this.getKeywordUnselectTextVisibility(d); })
            .text('remove');
    };
    KeywordsSelectorComponent.prototype.getKeywordsSelectorList = function () {
        var keywordsSelectorList = this.data.selectedKeywords.concat(this.data.keywords);
        keywordsSelectorList = keywordsSelectorList.filter(function (item, index, array) { return (data_utils_1.getIndexOfKeyword(item, array) === index); });
        data_utils_1.sortKeywords(keywordsSelectorList);
        return keywordsSelectorList;
    };
    KeywordsSelectorComponent.prototype.setChartsScalesDomain = function () {
        if (this.keywordsSelectorList.length === 0) {
            return;
        }
        var minDatetimeKeywordsDistributionData = d3_array_1.min(this.keywordsSelectorList[0].distribution, function (d) { return d.datetime; });
        var maxDatetimeKeywordsDistributionData = d3_array_1.max(this.keywordsSelectorList[0].distribution, function (d) { return d.datetime; });
        if (!!minDatetimeKeywordsDistributionData && !!maxDatetimeKeywordsDistributionData) {
            this.keywordsDistributionDatetimeScale
                .domain([minDatetimeKeywordsDistributionData, maxDatetimeKeywordsDistributionData]);
        }
    };
    return KeywordsSelectorComponent;
}());
exports.KeywordsSelectorComponent = KeywordsSelectorComponent;


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(66);


/* harmony default export */ __webpack_exports__["a"] = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["b" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(73);









/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(__WEBPACK_IMPORTED_MODULE_1__bisect__["c" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(37);





/* harmony default export */ __webpack_exports__["a"] = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * Object(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(15);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(37);




/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(11);


/* harmony default export */ __webpack_exports__["a"] = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(75);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = band;
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(76);



function band() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_nest__ = __webpack_require__(170);
/* unused harmony reexport nest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_set__ = __webpack_require__(171);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_map__ = __webpack_require__(39);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_keys__ = __webpack_require__(172);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_values__ = __webpack_require__(173);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_entries__ = __webpack_require__(174);
/* unused harmony reexport entries */








/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(39);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(39);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* unused harmony default export */ var _unused_webpack_default_export = (set);


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(85);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gray */
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* unused harmony export lch */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(77);




// https://beta.observablehq.com/@mbostock/lab-and-rgb
var K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
  if (r === g && g === b) x = z = y; else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(77);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(180);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(181);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ __webpack_exports__["a"] = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hslLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(16);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(16);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hclLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(16);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(16);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* harmony default export */ __webpack_exports__["b"] = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = piecewise;
function piecewise(interpolate, values) {
  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate(v, v = values[++i]);
  return function(t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(86);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, count == null ? 10 : count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
});


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(87);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (i0 > 0) { if (!+s[i]) break out; i0 = 0; } break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
});


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatPrefixAuto__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatRounded__ = __webpack_require__(195);



/* harmony default export */ __webpack_exports__["a"] = ({
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return Object(__WEBPACK_IMPORTED_MODULE_1__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_1__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_0__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(45);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(25);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(25);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(25);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(24);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["b" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ticks"])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pow;
/* harmony export (immutable) */ __webpack_exports__["b"] = sqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(24);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, pow().exponent(exponent));
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(7);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["quantile"])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ascending"]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(12);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = threshold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(7);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);


var millisecond = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(5);



var second = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(5);



var minute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(5);



var hour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(5);



var day = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thursday; });
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(5);



function weekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);


var month = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);


var year = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(5);



var utcMinute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(5);



var utcHour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(5);



var utcDay = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcThursday; });
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(5);



function utcWeekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);


var utcMonth = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);


var utcYear = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(47);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["c" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["v" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["u" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["m" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["b" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sequential;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(12);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      k10 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) * k10;
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], k10 = x0 === x1 ? 0 : 1 / (x1 - x0), scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = diverging;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(12);


function diverging(interpolator) {
  var x0 = 0,
      x1 = 0.5,
      x2 = 1,
      k10 = 1,
      k21 = 1,
      clamp = false;

  function scale(x) {
    var t = 0.5 + ((x = +x) - x1) * (x < x1 ? k10 : k21);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], x2 = +_[2], k10 = x0 === x1 ? 0 : 0.5 / (x1 - x0), k21 = x1 === x2 ? 0 : 0.5 / (x2 - x1), scale) : [x0, x1, x2];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return diverging(interpolator).domain([x0, x1, x2]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(18);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        da = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["m" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
      context.moveTo(r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a0), r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        context.moveTo(r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a1), r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(r0 * r0 + r1 * r1)),
          rc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var p0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap)),
            p1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a01),
          y01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a01),
          x10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a10),
          y10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var x11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a11),
            y11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a11),
            x00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a00),
            y00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])((ax * bx + ay * by) / (Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(ax * ax + ay * ay) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(bx * bx + by * by))) / 2),
              lc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r0 - lc) / (kc - 1));
          rc1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */] / 2;
    return [Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a) * r, Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(18);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */]),
      padAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lineRadial__ = __webpack_require__(97);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  var a = Object(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["b" /* lineRadial */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linkHorizontal;
/* harmony export (immutable) */ __webpack_exports__["c"] = linkVertical;
/* harmony export (immutable) */ __webpack_exports__["b"] = linkRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pointRadial__ = __webpack_require__(98);






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      context = null;

  function link() {
    var buffer, argv = __WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0),
      p1 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0 = (y0 + y1) / 2),
      p2 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y0),
      p3 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return symbols; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(10);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var type = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(28);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(28);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(28);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(51);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(51);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(27);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* harmony export (immutable) */ __webpack_exports__["b"] = monotoneY;
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = stepBefore;
/* harmony export (immutable) */ __webpack_exports__["b"] = stepAfter;
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(20);





function stackValue(d, key) {
  return d[key];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
});


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(52);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(series).reverse();
});


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["b" /* sum */]),
      order = Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interrupt__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transition__ = __webpack_require__(254);




__WEBPACK_IMPORTED_MODULE_0_d3_selection__["selection"].prototype.interrupt = __WEBPACK_IMPORTED_MODULE_1__interrupt__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_d3_selection__["selection"].prototype.transition = __WEBPACK_IMPORTED_MODULE_2__transition__["a" /* default */];


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interrupt__ = __webpack_require__(109);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  return this.each(function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__interrupt__["a" /* default */])(this, name);
  });
});


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_dispatch__ = __webpack_require__(251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_dispatch__["a"]; });



/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

/* harmony default export */ __webpack_exports__["a"] = (dispatch);


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */];
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
});


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(54);


/* unused harmony default export */ var _unused_webpack_default_export = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */], total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? Object(__WEBPACK_IMPORTED_MODULE_0__timer__["b" /* now */])() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
});


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_ease__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_timer__ = __webpack_require__(110);





var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: __WEBPACK_IMPORTED_MODULE_2_d3_ease__["a" /* easeCubicInOut */]
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["a" /* now */])(), defaultTiming;
    }
  }
  return timing;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var id,
      timing;

  if (name instanceof __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]) {
    id = name._id, name = name._name;
  } else {
    id = Object(__WEBPACK_IMPORTED_MODULE_0__transition_index__["c" /* newId */])(), (timing = defaultTiming).time = Object(__WEBPACK_IMPORTED_MODULE_3_d3_timer__["a" /* now */])(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        Object(__WEBPACK_IMPORTED_MODULE_1__transition_schedule__["e" /* default */])(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */](groups, this._parents, name, id);
});


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(111);





function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttribute(name);
    value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["namespace"])(name), i = fullname === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["interpolateTransformSvg"] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value + ""));
});


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);


function attrTweenNS(fullname, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttributeNS(fullname.space, fullname.local, i(t));
    };
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttribute(name, i(t));
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["namespace"])(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
});


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(4);


function delayFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */])(this, id).delay = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).delay;
});


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(4);


function durationFunction(id, value) {
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).duration = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).duration;
});


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(4);


function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */])(this, id).ease = value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).ease;
});


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["matcher"])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, this._name, this._id);
});


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (function(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](merges, this._parents, this._name, this._id);
});


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schedule__ = __webpack_require__(4);


function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? __WEBPACK_IMPORTED_MODULE_0__schedule__["g" /* init */] : __WEBPACK_IMPORTED_MODULE_0__schedule__["h" /* set */];
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? Object(__WEBPACK_IMPORTED_MODULE_0__schedule__["f" /* get */])(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
});


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.on("end.remove", removeFunction(this._id));
});


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["selector"])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(subgroup[i], name, id, i, subgroup, Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id));
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, this._parents, name, id);
});


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = Object(__WEBPACK_IMPORTED_MODULE_0_d3_selection__["selectorAll"])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["f" /* get */])(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["e" /* default */])(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Transition */](subgroups, parents, name, id);
});


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(1);


var Selection = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["selection"].prototype.constructor;

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Selection(this._groups, this._parents);
});


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tween__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(111);





function styleRemove(name, interpolate) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["style"])(this, name),
        value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["style"])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function styleRemoveEnd(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["style"])(this, name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["style"])(this, name),
        value1 = value(this);
    if (value1 == null) value1 = (this.style.removeProperty(name), Object(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["style"])(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var i = (name += "") === "transform" ? __WEBPACK_IMPORTED_MODULE_0_d3_interpolate__["interpolateTransformCss"] : __WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */];
  return value == null ? this
          .styleTween(name, styleRemove(name, i))
          .on("end.style." + name, styleRemoveEnd(name))
      : this.styleTween(name, typeof value === "function"
          ? styleFunction(name, i, Object(__WEBPACK_IMPORTED_MODULE_2__tween__["b" /* tweenValue */])(this, "style." + name, value))
          : styleConstant(name, i, value + ""), priority);
});


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function styleTween(name, value, priority) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.style.setProperty(name, i(t), priority);
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
});


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tween__ = __webpack_require__(30);


function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(Object(__WEBPACK_IMPORTED_MODULE_0__tween__["b" /* tweenValue */])(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
});


/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schedule__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  var name = this._name,
      id0 = this._id,
      id1 = Object(__WEBPACK_IMPORTED_MODULE_0__index__["c" /* newId */])();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["f" /* get */])(node, id0);
        Object(__WEBPACK_IMPORTED_MODULE_1__schedule__["e" /* default */])(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Transition */](groups, this._parents, name, id1);
});


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_linear__ = __webpack_require__(272);
/* unused harmony reexport easeLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_quad__ = __webpack_require__(273);
/* unused harmony reexport easeQuad */
/* unused harmony reexport easeQuadIn */
/* unused harmony reexport easeQuadOut */
/* unused harmony reexport easeQuadInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubic__ = __webpack_require__(274);
/* unused harmony reexport easeCubic */
/* unused harmony reexport easeCubicIn */
/* unused harmony reexport easeCubicOut */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_poly__ = __webpack_require__(275);
/* unused harmony reexport easePoly */
/* unused harmony reexport easePolyIn */
/* unused harmony reexport easePolyOut */
/* unused harmony reexport easePolyInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_sin__ = __webpack_require__(276);
/* unused harmony reexport easeSin */
/* unused harmony reexport easeSinIn */
/* unused harmony reexport easeSinOut */
/* unused harmony reexport easeSinInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_exp__ = __webpack_require__(277);
/* unused harmony reexport easeExp */
/* unused harmony reexport easeExpIn */
/* unused harmony reexport easeExpOut */
/* unused harmony reexport easeExpInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_circle__ = __webpack_require__(278);
/* unused harmony reexport easeCircle */
/* unused harmony reexport easeCircleIn */
/* unused harmony reexport easeCircleOut */
/* unused harmony reexport easeCircleInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_bounce__ = __webpack_require__(279);
/* unused harmony reexport easeBounce */
/* unused harmony reexport easeBounceIn */
/* unused harmony reexport easeBounceOut */
/* unused harmony reexport easeBounceInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_back__ = __webpack_require__(280);
/* unused harmony reexport easeBack */
/* unused harmony reexport easeBackIn */
/* unused harmony reexport easeBackOut */
/* unused harmony reexport easeBackInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_elastic__ = __webpack_require__(281);
/* unused harmony reexport easeElastic */
/* unused harmony reexport easeElasticIn */
/* unused harmony reexport easeElasticOut */
/* unused harmony reexport easeElasticInOut */





















/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export linear */
function linear(t) {
  return +t;
}


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export quadIn */
/* unused harmony export quadOut */
/* unused harmony export quadInOut */
function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cubicIn */
/* unused harmony export cubicOut */
/* harmony export (immutable) */ __webpack_exports__["a"] = cubicInOut;
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export polyIn */
/* unused harmony export polyOut */
/* unused harmony export polyInOut */
var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sinIn */
/* unused harmony export sinOut */
/* unused harmony export sinInOut */
var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export expIn */
/* unused harmony export expOut */
/* unused harmony export expInOut */
function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export circleIn */
/* unused harmony export circleOut */
/* unused harmony export circleInOut */
function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bounceIn */
/* unused harmony export bounceOut */
/* unused harmony export bounceInOut */
var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export backIn */
/* unused harmony export backOut */
/* unused harmony export backInOut */
var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export elasticIn */
/* unused harmony export elasticOut */
/* unused harmony export elasticInOut */
var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transition_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transition_schedule__ = __webpack_require__(4);



var root = [null];

/* harmony default export */ __webpack_exports__["a"] = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > __WEBPACK_IMPORTED_MODULE_1__transition_schedule__["c" /* SCHEDULED */] && schedule.name === name) {
        return new __WEBPACK_IMPORTED_MODULE_0__transition_index__["a" /* Transition */]([[node]], root, name, +i);
      }
    }
  }

  return null;
});


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(284);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(14)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/resolve-url-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?sourceMap!./keywords-selector.component.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/resolve-url-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?sourceMap!./keywords-selector.component.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(13)(false);
// imports


// module
exports.push([module.i, ".keywords-selector {\n  overflow: auto;\n}\n\n.keywords-selector__keywords-selector-list {\n  display: block;\n  width: 100%;\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie {\n  cursor: pointer;\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie__distribution {\n  fill: transparent;\n  transition-property: fill;\n  transition-duration: 0.3s;\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie__text--term {\n  fill: #414649;\n  font-size: 16px;\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie__text--value {\n  fill: #81848b;\n  font-size: 11px;\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie__text--unselect {\n  fill: transparent;\n  font-size: 15px;\n  text-anchor: middle;\n  transition-property: fill;\n  transition-duration: 0.3s;\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie__container {\n  fill: transparent;\n  stroke: transparent;\n  stroke-width: 4px;\n  transition-property: fill, stroke;\n  transition-duration: 0.3s;\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie--enabled-1 .keywords-selector-serie__distribution {\n  fill: rgba(234, 185, 92, 0.7);\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie--enabled-2 .keywords-selector-serie__distribution {\n  fill: rgba(137, 185, 193, 0.7);\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie--not-hovered.keywords-selector-serie--enabled .keywords-selector-serie__container {\n  fill: rgba(255, 255, 255, 0.3);\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie--hovered.keywords-selector-serie--enabled-1 .keywords-selector-serie__container {\n  stroke: rgba(234, 185, 92, 0.7);\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie--hovered.keywords-selector-serie--enabled-2 .keywords-selector-serie__container {\n  stroke: rgba(137, 185, 193, 0.7);\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie--hovered.keywords-selector-serie--selected .keywords-selector-serie__text--unselect {\n  fill: white;\n  transition-delay: 0.15s;\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie--hovered.keywords-selector-serie--selected-1 .keywords-selector-serie__container {\n  fill: rgba(234, 185, 92, 0.8);\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie--hovered.keywords-selector-serie--selected-2 .keywords-selector-serie__container {\n  fill: rgba(137, 185, 193, 0.8);\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie--selected-1 .keywords-selector-serie__distribution {\n  fill: #eab95c;\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie--selected-1 .keywords-selector-serie__container {\n  stroke: #eab95c;\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie--selected-2 .keywords-selector-serie__distribution {\n  fill: #89b9c1;\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie--selected-2 .keywords-selector-serie__container {\n  stroke: #89b9c1;\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie--disabled {\n  pointer-events: none !important;\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie--disabled .keywords-selector-serie__distribution {\n  fill: #c3c5c8;\n}\n\n.keywords-selector__keywords-selector-list .keywords-selector-serie--disabled .keywords-selector-serie__container {\n  fill: rgba(255, 255, 255, 0.6);\n}", ""]);

// exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var d3_selection_1 = __webpack_require__(1);
__webpack_require__(53);
var details_component_enum_1 = __webpack_require__(56);
var seasons_utils_1 = __webpack_require__(286);
var keywords_details_component_1 = __webpack_require__(288);
var period_selector_component_1 = __webpack_require__(292);
__webpack_require__(299);
var SelectedKeywordsContainerComponent = (function () {
    function SelectedKeywordsContainerComponent(componentHtmlElement, size, config, data) {
        this.componentHtmlElement = componentHtmlElement;
        this.size = size;
        this.config = config;
        this.data = data;
        this.componentTemplate = "\n    <div class=\"selected-keywords-container__period-selector\">\n      <span class=\"selected-keywords-container__expander-control\"></span>\n    </div>\n    <div class=\"selected-keywords-container__keywords-details\">\n      <span class=\"selected-keywords-container__expander-control\"></span>\n    </div>\n  ";
        this.initializeComponent();
    }
    SelectedKeywordsContainerComponent.prototype.setConfig = function (config) {
        this.config = config;
        this.updateComponentChildrenHeight();
        this.updateComponentChildrenExpanderControlStyle(true);
        this.periodSelectorComponent.setConfig(this.config);
        this.keywordsDetailsComponent.setConfig(this.config);
    };
    SelectedKeywordsContainerComponent.prototype.setData = function (data) {
        this.data = data;
        this.updateComponentChildrenHeight();
        this.updateComponentChildrenExpanderControlStyle(true);
        this.generateSeasonsList();
        this.periodSelectorComponent.setData(this.data);
        this.keywordsDetailsComponent.setData(this.data);
    };
    SelectedKeywordsContainerComponent.prototype.resize = function (size) {
        this.size = size;
        this.updateComponentChildrenHeight();
        this.updateComponentChildrenExpanderControlStyle();
        this.periodSelectorComponent.resize({
            width: this.size.width,
            height: this.getPeriodSelectorComponentHeight()
        });
        this.keywordsDetailsComponent.resize({
            width: this.size.width,
            height: this.getKeywordsDetailsComponentHeight()
        });
    };
    SelectedKeywordsContainerComponent.prototype.onPeriodSelected = function (period) { };
    SelectedKeywordsContainerComponent.prototype.onDetailsComponentExpanderControlClick = function (detailsComponent) { };
    SelectedKeywordsContainerComponent.prototype.initializeComponent = function () {
        this.componentHtmlElement.innerHTML += this.componentTemplate;
        this.componentElement = d3_selection_1.select(this.componentHtmlElement)
            .classed('selected-keywords-container', true);
        this.seasonsList = seasons_utils_1.getSeasonsList(this.data);
        this.initializePeriodSelectorComponent();
        this.initializeKeywordsDetailsComponent();
    };
    SelectedKeywordsContainerComponent.prototype.initializePeriodSelectorComponent = function () {
        var _this = this;
        this.periodSelectorElement = this.componentElement
            .select('.selected-keywords-container__period-selector');
        this.periodSelectorComponent = new period_selector_component_1.PeriodSelectorComponent(this.periodSelectorElement.node(), {
            width: this.size.width,
            height: this.getPeriodSelectorComponentHeight()
        }, this.config, this.data, this.seasonsList);
        this.periodSelectorComponent.onPeriodSelected = function (period) {
            _this.onPeriodSelected(period);
        };
        this.periodSelectorExpanderControlElement = this.periodSelectorElement
            .select('.selected-keywords-container__expander-control')
            .style('transform', "translateY(" + (period_selector_component_1.PeriodSelectorComponent.componentHeightCollapsed / 2) + "px)")
            .on('click', function () { return _this.onDetailsComponentExpanderControlClick(details_component_enum_1.DetailsComponentEnum.PERIOD_SELECTOR); });
        this.updatePeriodSelectorExpanderControlStyle();
    };
    SelectedKeywordsContainerComponent.prototype.getPeriodSelectorComponentHeight = function () {
        if (this.isPeriodSelectorComponentExpanded()) {
            return Math.max(period_selector_component_1.PeriodSelectorComponent.componentMinHeightExpanded, (this.size.height - keywords_details_component_1.KeywordsDetailsComponent.componentHeightCollapsed));
        }
        return Math.max(period_selector_component_1.PeriodSelectorComponent.componentHeightCollapsed, (this.size.height - keywords_details_component_1.KeywordsDetailsComponent.getComponentHeightExpanded(this.size.width)));
    };
    SelectedKeywordsContainerComponent.prototype.isKeywordsDetailsComponentExpanded = function () {
        return ((this.config.expandedDetailsComponent === details_component_enum_1.DetailsComponentEnum.KEYWORDS_DETAILS) && (this.data.selectedKeywords.length > 0));
    };
    SelectedKeywordsContainerComponent.prototype.isPeriodSelectorComponentExpanded = function () {
        return ((this.config.expandedDetailsComponent === details_component_enum_1.DetailsComponentEnum.PERIOD_SELECTOR) || (this.data.selectedKeywords.length === 0) ||
            (!this.config.expandedDetailsComponent && (this.size.height < this.getComponentElementMinHeightToExpandAllChildren())));
    };
    SelectedKeywordsContainerComponent.prototype.getComponentElementMinHeightToExpandAllChildren = function () {
        return (period_selector_component_1.PeriodSelectorComponent.componentMinHeightExpanded +
            keywords_details_component_1.KeywordsDetailsComponent.getComponentHeightExpanded(this.size.width));
    };
    SelectedKeywordsContainerComponent.prototype.updatePeriodSelectorExpanderControlStyle = function (animateAction) {
        if (animateAction === void 0) { animateAction = false; }
        var isExpanderControlVisible = this.isPeriodSelectorExpanderControlVisible();
        var transitionDuration = ((isExpanderControlVisible || !animateAction) ? 0 : this.config.transitionsDurationInMillis);
        this.periodSelectorExpanderControlElement
            .classed('selected-keywords-container__expander-control--collapse', this.isPeriodSelectorComponentExpanded())
            .classed('selected-keywords-container__expander-control--expand', !this.isPeriodSelectorComponentExpanded())
            .transition().delay(transitionDuration)
            .style('visibility', function () { return (isExpanderControlVisible ? 'visible' : 'hidden'); });
        this.periodSelectorExpanderControlElement
            .transition().duration(this.config.transitionsDurationInMillis)
            .style('opacity', (isExpanderControlVisible ? 1 : 0));
    };
    SelectedKeywordsContainerComponent.prototype.isPeriodSelectorExpanderControlVisible = function () {
        return ((this.data.selectedKeywords.length > 0) && (this.size.height >= this.getComponentElementMinHeightToExpandAllChildren()));
    };
    SelectedKeywordsContainerComponent.prototype.initializeKeywordsDetailsComponent = function () {
        var _this = this;
        this.keywordsDetailsElement = this.componentElement
            .select('.selected-keywords-container__keywords-details');
        this.keywordsDetailsComponent = new keywords_details_component_1.KeywordsDetailsComponent(this.keywordsDetailsElement.node(), {
            width: this.size.width,
            height: this.getKeywordsDetailsComponentHeight()
        }, this.config, this.data, this.seasonsList);
        this.keywordsDetailsExpanderControlElement = this.keywordsDetailsElement
            .select('.selected-keywords-container__expander-control')
            .on('click', function () { return _this.onDetailsComponentExpanderControlClick(details_component_enum_1.DetailsComponentEnum.KEYWORDS_DETAILS); });
        this.updateKeywordsDetailsExpanderControlStyle();
    };
    SelectedKeywordsContainerComponent.prototype.getKeywordsDetailsComponentHeight = function () {
        if (this.isKeywordsDetailsComponentCollapsed()) {
            return keywords_details_component_1.KeywordsDetailsComponent.componentHeightCollapsed;
        }
        return keywords_details_component_1.KeywordsDetailsComponent.getComponentHeightExpanded(this.size.width);
    };
    SelectedKeywordsContainerComponent.prototype.isKeywordsDetailsComponentCollapsed = function () {
        return this.isPeriodSelectorComponentExpanded();
    };
    SelectedKeywordsContainerComponent.prototype.updateKeywordsDetailsExpanderControlStyle = function (animateAction) {
        if (animateAction === void 0) { animateAction = false; }
        var isExpanderControlVisible = this.isKeywordsDetailsExpanderControlVisible();
        var transitionDuration = ((isExpanderControlVisible || !animateAction) ? 0 : this.config.transitionsDurationInMillis);
        this.keywordsDetailsExpanderControlElement
            .classed('selected-keywords-container__expander-control--collapse', this.isKeywordsDetailsComponentExpanded())
            .classed('selected-keywords-container__expander-control--expand', !this.isKeywordsDetailsComponentExpanded())
            .transition().delay(transitionDuration)
            .style('visibility', function () { return (isExpanderControlVisible ? 'visible' : 'hidden'); });
        this.keywordsDetailsExpanderControlElement
            .transition().duration(this.config.transitionsDurationInMillis)
            .style('opacity', (isExpanderControlVisible ? 1 : 0));
    };
    SelectedKeywordsContainerComponent.prototype.isKeywordsDetailsExpanderControlVisible = function () {
        return ((this.data.selectedKeywords.length > 0) && !this.isPeriodSelectorExpanderControlVisible());
    };
    SelectedKeywordsContainerComponent.prototype.updateComponentChildrenHeight = function () {
        this.periodSelectorComponent.setComponentHeight(this.getPeriodSelectorComponentHeight());
        this.keywordsDetailsComponent.setComponentHeight(this.getKeywordsDetailsComponentHeight());
    };
    SelectedKeywordsContainerComponent.prototype.updateComponentChildrenExpanderControlStyle = function (animateActions) {
        this.updatePeriodSelectorExpanderControlStyle(animateActions);
        this.updateKeywordsDetailsExpanderControlStyle(animateActions);
    };
    SelectedKeywordsContainerComponent.prototype.generateSeasonsList = function () {
        this.seasonsList = seasons_utils_1.getSeasonsList(this.data);
        this.periodSelectorComponent.setSeasonsList(this.seasonsList);
        this.keywordsDetailsComponent.setSeasonsList(this.seasonsList);
    };
    return SelectedKeywordsContainerComponent;
}());
exports.SelectedKeywordsContainerComponent = SelectedKeywordsContainerComponent;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var d3_array_1 = __webpack_require__(2);
var season_id_enum_1 = __webpack_require__(287);
function getSeasonsList(data) {
    var startDateFullPeriod;
    var endDateFullPeriod;
    var keyword = (data.selectedKeywords[0] || data.keywords[0]);
    if (!!keyword) {
        startDateFullPeriod = d3_array_1.min(keyword.distribution, function (d) { return d.datetime; });
        endDateFullPeriod = d3_array_1.max(keyword.distribution, function (d) { return d.datetime; });
    }
    else {
        startDateFullPeriod = generateCurrentSeasonGivenDate(new Date(Date.now()), 0).startDate;
        endDateFullPeriod = new Date(startDateFullPeriod.getTime());
        startDateFullPeriod.setUTCFullYear(startDateFullPeriod.getUTCFullYear() - 1);
        endDateFullPeriod.setUTCDate(endDateFullPeriod.getUTCDate() - 1);
    }
    if (!!startDateFullPeriod && !!endDateFullPeriod) {
        return generateSeasonsListBetweenDates(startDateFullPeriod, endDateFullPeriod);
    }
}
exports.getSeasonsList = getSeasonsList;
function generateSeasonsListBetweenDates(startDate, endDate) {
    var seasonsList = [];
    var date = new Date(startDate.getTime());
    while (date < endDate) {
        var season = generateCurrentSeasonGivenDate(date, seasonsList.length);
        seasonsList.push(season);
        date = new Date(season.endDate);
        date.setUTCDate(date.getUTCDate() + 1);
    }
    seasonsList[0].startDate = new Date(startDate);
    seasonsList[seasonsList.length - 1].endDate = new Date(endDate);
    return seasonsList;
}
function generateCurrentSeasonGivenDate(date, seasonOrder) {
    var dateMonth = date.getUTCMonth();
    var dateYear = date.getUTCFullYear();
    if ((dateMonth % 11) < 2) {
        if (dateMonth < 2) {
            dateYear -= 1;
        }
        return {
            id: season_id_enum_1.SeasonIdEnum.WINTER,
            order: seasonOrder,
            startDate: new Date(Date.UTC(dateYear, 11, 1)),
            endDate: new Date(Date.UTC((dateYear + 1), 2, 1))
        };
    }
    if (dateMonth < 5) {
        return {
            id: season_id_enum_1.SeasonIdEnum.SPRING,
            order: seasonOrder,
            startDate: new Date(Date.UTC(dateYear, 2, 1)),
            endDate: new Date(Date.UTC(dateYear, 5, 1))
        };
    }
    if (dateMonth < 8) {
        return {
            id: season_id_enum_1.SeasonIdEnum.SUMMER,
            order: seasonOrder,
            startDate: new Date(Date.UTC(dateYear, 5, 1)),
            endDate: new Date(Date.UTC(dateYear, 8, 1))
        };
    }
    return {
        id: season_id_enum_1.SeasonIdEnum.AUTUMN,
        order: seasonOrder,
        startDate: new Date(Date.UTC(dateYear, 8, 1)),
        endDate: new Date(Date.UTC(dateYear, 11, 1))
    };
}


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SeasonIdEnum;
(function (SeasonIdEnum) {
    SeasonIdEnum["WINTER"] = "winter";
    SeasonIdEnum["SPRING"] = "spring";
    SeasonIdEnum["SUMMER"] = "summer";
    SeasonIdEnum["AUTUMN"] = "autumn";
})(SeasonIdEnum = exports.SeasonIdEnum || (exports.SeasonIdEnum = {}));


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var d3_array_1 = __webpack_require__(2);
var d3_interpolate_1 = __webpack_require__(8);
var d3_scale_1 = __webpack_require__(38);
var d3_selection_1 = __webpack_require__(1);
var d3_shape_1 = __webpack_require__(48);
__webpack_require__(53);
var data_utils_1 = __webpack_require__(55);
__webpack_require__(289);
var KeywordsDetailsComponent = (function () {
    function KeywordsDetailsComponent(componentHtmlElement, size, config, data, seasonsList) {
        var _this = this;
        this.componentHtmlElement = componentHtmlElement;
        this.size = size;
        this.config = config;
        this.data = data;
        this.seasonsList = seasonsList;
        this.componentTemplate = "\n    <svg class=\"keywords-details__selected-keywords-list\"></svg>\n  ";
        this.relatedQueriesToShow = 5;
        this.selectedKeywordsSeasonChartScale = d3_scale_1.scaleLinear()
            .range([0, (Math.PI * 2)]);
        this.relatedQueriesPercentageChartScale = d3_scale_1.scaleLinear();
        this.selectedKeywordMargin = 3;
        this.selectedKeywordPadding = 3;
        this.selectedKeywordContainerRadius = 3;
        this.selectedKeywordsSeasonChartInnerMinRadius = 22;
        this.selectedKeywordsListSerieKeywordChartAnimationAnglesList = {};
        Object.values(KpiEnum).forEach(function (kpi) {
            _this.selectedKeywordsListSerieKeywordChartAnimationAnglesList[kpi] = [];
            for (var index = 0; index < _this.config.maxKeywordsSelected; index++) {
                _this.selectedKeywordsListSerieKeywordChartAnimationAnglesList[kpi].push(0);
            }
        });
        this.initializeComponent();
    }
    KeywordsDetailsComponent.getComponentHeightExpanded = function (componentContainerWidth) {
        var componentHeightExpanded = KeywordsDetailsComponent.relatedQueriesListHeight;
        if (componentContainerWidth < KeywordsDetailsComponent.minWidthToShowKeywordGroupExpaded) {
            componentHeightExpanded += KeywordsDetailsComponent.componentHeightCollapsed;
        }
        return componentHeightExpanded;
    };
    KeywordsDetailsComponent.capitalizeString = function (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };
    KeywordsDetailsComponent.prototype.setConfig = function (config) {
        this.config = config;
        this.renderSelectedKeywordsList();
    };
    KeywordsDetailsComponent.prototype.setData = function (data) {
        this.data = data;
        this.renderSelectedKeywordsList();
    };
    KeywordsDetailsComponent.prototype.resize = function (size) {
        this.size = size;
        this.setChartsScalesRange();
        this.resizeSelectedKeywordsList();
    };
    KeywordsDetailsComponent.prototype.setComponentHeight = function (componentHeight) {
        this.size.height = componentHeight;
    };
    KeywordsDetailsComponent.prototype.setSeasonsList = function (seasonsList) {
        this.seasonsList = seasonsList;
    };
    KeywordsDetailsComponent.prototype.onKeywordMouseOver = function (keyword) { };
    KeywordsDetailsComponent.prototype.onKeywordMouseOut = function () { };
    KeywordsDetailsComponent.prototype.onKeywordClick = function (keyword) { };
    KeywordsDetailsComponent.prototype.getLureRelatedQueries = function (keyword) {
        var terms = ['lorem', 'lorem ipsum', 'lorem sit', 'lorem amet', 'lorem dolor'];
        var percents = [.6, .2, .1, .08, .02];
        return terms.map(function (term, i) {
            return {
                terms: term,
                queryCount: Math.round(keyword.queryCount * percents[i]),
                distribution: []
            };
        });
    };
    KeywordsDetailsComponent.prototype.initializeComponent = function () {
        this.componentHtmlElement.innerHTML += this.componentTemplate;
        this.componentElement = d3_selection_1.select(this.componentHtmlElement)
            .classed('keywords-details', true);
        this.selectedKeywordsListElement = this.componentElement
            .select('.keywords-details__selected-keywords-list')
            .attr('height', this.size.height);
        this.setChartsScalesRange();
        this.renderSelectedKeywordsList();
    };
    KeywordsDetailsComponent.prototype.setChartsScalesRange = function () {
        var maxRangeOfPercentageChartScale = ((this.getRelatedQueriesSerieWidth() -
            this.getRelatedQueriesSerieQueryPercentageChartGroupPositionX()) - (this.selectedKeywordPadding * 2));
        this.relatedQueriesPercentageChartScale
            .range([0, maxRangeOfPercentageChartScale]);
    };
    KeywordsDetailsComponent.prototype.renderSelectedKeywordsList = function () {
        this.selectedKeywordsListElement
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('height', this.size.height);
        this.renderSelectedKeywordsContainers();
        var selectedKeywordsSeries = this.selectedKeywordsListElement
            .selectAll('.selected-keywords-serie')
            .data(this.data.selectedKeywords, function (d) { return data_utils_1.getKeywordId(d); });
        this.removeSelectedKeywordsListSeries(selectedKeywordsSeries);
        this.updateSelectedKeywordsListSeries(selectedKeywordsSeries);
        this.enterSelectedKeywordsListSeries(selectedKeywordsSeries);
    };
    KeywordsDetailsComponent.prototype.renderSelectedKeywordsContainers = function () {
        var selectedKeywordsListSerieWidth = this.getSelectedKeywordsListSerieWidth();
        var selectedKeywordsListSerieHeight = this.getSelectedKeywordsListSerieHeight();
        var _loop_1 = function (selectionOrder) {
            var selectedKeywordContainer = this_1.selectedKeywordsListElement
                .select(".selected-keyword-container--" + selectionOrder);
            if (selectedKeywordContainer.empty()) {
                selectedKeywordContainer = this_1.selectedKeywordsListElement
                    .append('rect')
                    .attr('class', "selected-keyword-container selected-keyword-container--" + selectionOrder)
                    .attr('transform', "translate(" + this_1.getSelectedKeywordsListSeriePositionX(selectionOrder) + ", 0)")
                    .attr('x', this_1.selectedKeywordMargin)
                    .attr('y', this_1.selectedKeywordMargin)
                    .attr('width', selectedKeywordsListSerieWidth)
                    .attr('height', selectedKeywordsListSerieHeight)
                    .attr('rx', this_1.selectedKeywordContainerRadius)
                    .attr('ry', this_1.selectedKeywordContainerRadius);
            }
            else {
                selectedKeywordContainer
                    .transition().duration(this_1.config.transitionsDurationInMillis)
                    .attr('transform', "translate(" + this_1.getSelectedKeywordsListSeriePositionX(selectionOrder) + ", 0)")
                    .attr('height', selectedKeywordsListSerieHeight);
            }
            selectedKeywordContainer
                .classed('selected-keyword-container--selected', this_1.data.selectedKeywords.some(function (d) { return (d.selectionOrder === selectionOrder); }));
        };
        var this_1 = this;
        for (var selectionOrder = 1; selectionOrder <= this.config.maxKeywordsSelected; selectionOrder++) {
            _loop_1(selectionOrder);
        }
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieWidth = function () {
        return ((this.size.width / this.config.maxKeywordsSelected) - (this.selectedKeywordMargin * 2));
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieHeight = function () {
        return (this.size.height - (this.selectedKeywordMargin * 2));
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSeriePositionX = function (selectionOrder) {
        return ((this.size.width / this.config.maxKeywordsSelected) * (selectionOrder - 1));
    };
    KeywordsDetailsComponent.prototype.removeSelectedKeywordsListSeries = function (series) {
        var exitSeries = series.exit();
        exitSeries
            .transition().duration(this.config.transitionsDurationInMillis)
            .style('opacity', 0);
        exitSeries
            .style('pointer-events', 'none')
            .transition().delay(this.config.transitionsDurationInMillis)
            .remove();
    };
    KeywordsDetailsComponent.prototype.updateSelectedKeywordsListSeries = function (series) {
        var _this = this;
        series
            .style('pointer-events', 'auto')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('transform', function (d) { return "translate(" + _this.getSelectedKeywordsListSeriePositionX(d.selectionOrder) + ", 0)"; })
            .style('opacity', 1);
        this.updateKeywordGroupSelectedKeywordsListSeries(series);
        this.updateRelatedQueriesGroupSelectedKeywordsListSeries(series);
    };
    KeywordsDetailsComponent.prototype.updateKeywordGroupSelectedKeywordsListSeries = function (series) {
        var isKeywordGroupExpanded = this.isKeywordGroupSelectedKeywordsListSeriesExpanded();
        series
            .select('.selected-keywords-serie__keyword-container')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('width', this.getSelectedKeywordsListSerieKeywordContainerWidth(isKeywordGroupExpanded))
            .attr('height', this.getSelectedKeywordsListSerieKeywordContainerHeight(isKeywordGroupExpanded));
        this.updateKeywordChartGroupSelectedKeywordsListSeries(series, isKeywordGroupExpanded);
        this.updateKeywordTextGroupSelectedKeywordsListSeries(series, isKeywordGroupExpanded);
    };
    KeywordsDetailsComponent.prototype.isKeywordGroupSelectedKeywordsListSeriesExpanded = function () {
        return ((this.size.height > KeywordsDetailsComponent.componentHeightCollapsed) &&
            (this.size.width >= KeywordsDetailsComponent.minWidthToShowKeywordGroupExpaded));
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordContainerWidth = function (isKeywordGroupExpanded) {
        var containerWidth = (this.getSelectedKeywordsListSerieWidth() - (this.selectedKeywordPadding * 2));
        if (isKeywordGroupExpanded) {
            containerWidth = ((containerWidth / 2) - this.selectedKeywordPadding);
        }
        return containerWidth;
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordContainerHeight = function (isKeywordGroupExpanded) {
        var containerHeight = (isKeywordGroupExpanded ? KeywordsDetailsComponent.getComponentHeightExpanded(this.size.width)
            : KeywordsDetailsComponent.componentHeightCollapsed);
        return (containerHeight - ((this.selectedKeywordMargin + this.selectedKeywordPadding) * 2));
    };
    KeywordsDetailsComponent.prototype.updateKeywordChartGroupSelectedKeywordsListSeries = function (series, isKeywordGroupExpanded) {
        var _this = this;
        Object.values(KpiEnum).forEach(function (kpi) {
            _this.updateKpiKeywordChartGroupSelectedKeywordsListSeries(kpi, series, isKeywordGroupExpanded);
        });
    };
    KeywordsDetailsComponent.prototype.updateKpiKeywordChartGroupSelectedKeywordsListSeries = function (kpi, series, isKeywordGroupExpanded) {
        var _this = this;
        var chartPositionX = this.getSelectedKeywordsListSerieKeywordKpiChartGroupCenterPositionX(kpi, isKeywordGroupExpanded);
        var chartPositionY = this.getSelectedKeywordsListSerieKeywordChartGroupCenterPositionY(isKeywordGroupExpanded);
        var keywordChartGroup = series
            .select(".selected-keywords-serie__keyword-chart-group--" + kpi);
        keywordChartGroup
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('transform', "translate(" + chartPositionX + ", " + chartPositionY + ")")
            .style('opacity', this.getSelectedKeywordsListSerieKeywordChartGroupOpacity(isKeywordGroupExpanded));
        keywordChartGroup
            .select('.selected-keywords-serie__keyword-chart-background')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('r', this.getSelectedKeywordsListSerieKeywordChartRadius(isKeywordGroupExpanded));
        keywordChartGroup
            .select('.selected-keywords-serie__keyword-chart-foreground')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attrTween('d', function (d) { return _this.animateSelectedKeywordsListSerieKeywordChartCommands(kpi, d, isKeywordGroupExpanded); });
        var centerContainerRadius = this.getSelectedKeywordsListSerieKeywordChartCenterContainerRadius(isKeywordGroupExpanded);
        keywordChartGroup
            .select('.selected-keywords-serie__keyword-chart-center-container')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('r', centerContainerRadius);
        keywordChartGroup
            .select('.selected-keywords-serie__keyword-chart-text-container')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('x', -centerContainerRadius)
            .attr('y', -centerContainerRadius)
            .attr('height', (centerContainerRadius * 2))
            .attr('width', (centerContainerRadius * 2));
        keywordChartGroup
            .select('.selected-keywords-serie__keyword-text--count-percentage')
            .text(function (d) { return _this.getSelectedKeywordsListSerieKeywordKpiChartTextCountPercentageValue(kpi, d); });
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordKpiChartGroupCenterPositionX = function (kpi, isKeywordGroupExpanded) {
        return (_a = {},
            _a[KpiEnum.FINDABILITY] = ((this.getSelectedKeywordsListSerieKeywordChartGroupCenterPositionX(isKeywordGroupExpanded) / 2) +
                this.selectedKeywordPadding),
            _a[KpiEnum.ADD2CART] = ((this.getSelectedKeywordsListSerieKeywordChartGroupCenterPositionX(isKeywordGroupExpanded) * 1.5) -
                this.selectedKeywordPadding),
            _a)[kpi];
        var _a;
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordChartGroupCenterPositionX = function (isKeywordGroupExpanded) {
        return ((this.getSelectedKeywordsListSerieKeywordChartGroupWidth(isKeywordGroupExpanded) / 2) + this.selectedKeywordPadding);
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordChartGroupWidth = function (isKeywordGroupExpanded) {
        if (isKeywordGroupExpanded) {
            return this.getSelectedKeywordsListSerieKeywordContainerWidth(isKeywordGroupExpanded);
        }
        return this.getSelectedKeywordsListSerieKeywordTextContainerPositionX(isKeywordGroupExpanded);
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordChartGroupCenterPositionY = function (isKeywordGroupExpanded) {
        var chartGroupPositionY = ((isKeywordGroupExpanded ? this.getSelectedKeywordsListSerieKeywordTextContainerHeight(isKeywordGroupExpanded) : 0) + this.selectedKeywordPadding);
        return (chartGroupPositionY + (this.getSelectedKeywordsListSerieKeywordChartGroupHeight(isKeywordGroupExpanded) / 2));
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordChartGroupOpacity = function (isKeywordGroupExpanded) {
        return ((isKeywordGroupExpanded && (this.size.width >= KeywordsDetailsComponent.minWidthToShowKeywordGroupExpaded)) ? 1 : 0);
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordChartRadius = function (isKeywordGroupExpanded) {
        return ((Math.min((this.getSelectedKeywordsListSerieKeywordChartGroupWidth(isKeywordGroupExpanded) / 2), this.getSelectedKeywordsListSerieKeywordChartGroupHeight(isKeywordGroupExpanded)) / 2) - (this.selectedKeywordPadding * 3));
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordChartGroupHeight = function (isKeywordGroupExpanded) {
        var chartGroupHeight = this.getSelectedKeywordsListSerieKeywordContainerHeight(isKeywordGroupExpanded);
        if (isKeywordGroupExpanded) {
            chartGroupHeight -= this.getSelectedKeywordsListSerieKeywordTextContainerHeight(isKeywordGroupExpanded);
        }
        return chartGroupHeight;
    };
    KeywordsDetailsComponent.prototype.animateSelectedKeywordsListSerieKeywordChartCommands = function (kpi, keyword, isKeywordGroupExpanded) {
        var _this = this;
        var kpiPct = (_a = {},
            _a[KpiEnum.FINDABILITY] = this.getSelectedKeywordSuccessCountPercentageFilteredBySeason(keyword, this.getSeasonSelected()),
            _a[KpiEnum.ADD2CART] = this.getSelectedKeywordAdd2cartCountPercentageFilteredBySeason(keyword, this.getSeasonSelected()),
            _a)[kpi];
        var angle = this.selectedKeywordsSeasonChartScale(kpiPct);
        var itp = d3_interpolate_1.interpolate(this.selectedKeywordsListSerieKeywordChartAnimationAnglesList[kpi][keyword.selectionOrder - 1], angle);
        return function (tr) {
            var animationAngle = itp(tr);
            _this.selectedKeywordsListSerieKeywordChartAnimationAnglesList[kpi][keyword.selectionOrder - 1] = animationAngle;
            return _this.getSelectedKeywordsListSerieKeywordChartCommandsGivenAngle(animationAngle, isKeywordGroupExpanded);
        };
        var _a;
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordChartCommandsGivenAngle = function (angle, isKeywordGroupExpanded) {
        return d3_shape_1.arc()
            .innerRadius(0)
            .outerRadius(this.getSelectedKeywordsListSerieKeywordChartRadius(isKeywordGroupExpanded))
            .startAngle(0)
            .endAngle(angle)();
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordChartCenterContainerRadius = function (isKeywordGroupExpanded) {
        return Math.max((this.getSelectedKeywordsListSerieKeywordChartRadius(isKeywordGroupExpanded) * (2 / 3)), this.selectedKeywordsSeasonChartInnerMinRadius);
    };
    KeywordsDetailsComponent.prototype.getSeasonSelected = function () {
        var _this = this;
        if (!!this.config.selectedPeriod.startDate && !!this.config.selectedPeriod.endDate) {
            return this.seasonsList.find(function (d) { return ((d.startDate.getTime() === _this.config.selectedPeriod.startDate.getTime()) &&
                (d.endDate.getTime() === _this.config.selectedPeriod.endDate.getTime())); });
        }
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordKpiChartTextCountPercentageValue = function (kpi, keyword) {
        var kpiPct = (_a = {},
            _a[KpiEnum.FINDABILITY] = this.getSelectedKeywordSuccessCountPercentageFilteredBySeason(keyword, this.getSeasonSelected()),
            _a[KpiEnum.ADD2CART] = this.getSelectedKeywordAdd2cartCountPercentageFilteredBySeason(keyword, this.getSeasonSelected()),
            _a)[kpi];
        return (kpiPct * 100).toLocaleString('en', {
            maximumSignificantDigits: 3
        }) + "%";
        var _a;
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordQueryCountPercentageFilteredBySeason = function (keyword, season) {
        if (keyword.queryCount > 0) {
            return (this.getSelectedKeywordQueryCountFilteredBySeason(keyword, season) / keyword.queryCount);
        }
        return 0;
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordSuccessCountPercentageFilteredBySeason = function (keyword, season) {
        if (keyword.successCount > 0) {
            return (this.getSelectedKeywordSuccessCountFilteredBySeason(keyword, season) / keyword.queryCount);
        }
        return 0;
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordAdd2cartCountPercentageFilteredBySeason = function (keyword, season) {
        if (keyword.successCount > 0) {
            return (this.getSelectedKeywordAdd2cartCountFilteredBySeason(keyword, season) / keyword.queryCount);
        }
        return 0;
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordQueryCountFilteredBySeason = function (keyword, season) {
        if (!season) {
            return keyword.queryCount;
        }
        return d3_array_1.sum(keyword.distribution.filter(function (d) { return ((d.datetime >= season.startDate) && (d.datetime < season.endDate)); }), function (d) { return d.queryCount; });
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordNoResultsCountFilteredBySeason = function (keyword, season) {
        if (!season) {
            return keyword.noResultsCount;
        }
        return d3_array_1.sum(keyword.distribution.filter(function (d) { return ((d.datetime >= season.startDate) && (d.datetime < season.endDate)); }), function (d) { return d.noResultsCount; });
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordSuccessCountFilteredBySeason = function (keyword, season) {
        if (!season) {
            return keyword.successCount;
        }
        return d3_array_1.sum(keyword.distribution.filter(function (d) { return ((d.datetime >= season.startDate) && (d.datetime < season.endDate)); }), function (d) { return d.successCount; });
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordAdd2cartCountFilteredBySeason = function (keyword, season) {
        if (!season) {
            return keyword.add2cartCount;
        }
        return d3_array_1.sum(keyword.distribution.filter(function (d) { return ((d.datetime >= season.startDate) && (d.datetime < season.endDate)); }), function (d) { return d.add2cartCount; });
    };
    KeywordsDetailsComponent.prototype.updateKeywordTextGroupSelectedKeywordsListSeries = function (series, isKeywordGroupExpanded) {
        var _this = this;
        series
            .select('.selected-keywords-serie__keyword-text-container')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('width', this.getSelectedKeywordsListSerieKeywordContainerWidth(isKeywordGroupExpanded))
            .attr('height', this.getSelectedKeywordsListSerieKeywordTextContainerHeight(isKeywordGroupExpanded));
        series
            .select('.selected-keywords-serie__keyword-text-group--queries')
            .select('.selected-keywords-serie__keyword-text--count-value')
            .text(function (d) { return _this.getSelectedKeywordsListSerieKeywordTextQueryCountValue(d); });
        series
            .select('.selected-keywords-serie__keyword-text-group--no-results')
            .select('.selected-keywords-serie__keyword-text--count-value')
            .text(function (d) { return _this.getSelectedKeywordsListSerieKeywordTextNoResultsCountValue(d); });
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordTextContainerPositionX = function (isKeywordGroupExpanded) {
        var textContainerPositionX = this.selectedKeywordPadding;
        if (!isKeywordGroupExpanded) {
            textContainerPositionX += (this.getSelectedKeywordsListSerieKeywordContainerWidth(isKeywordGroupExpanded) * (2 / 5));
        }
        return textContainerPositionX;
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordTextContainerHeight = function (isKeywordGroupExpanded) {
        var textContainerHeight = this.getSelectedKeywordsListSerieKeywordContainerHeight(isKeywordGroupExpanded);
        if (isKeywordGroupExpanded) {
            textContainerHeight /= 3;
        }
        return textContainerHeight;
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordTextQueryCountValue = function (keyword) {
        var seasonSelected = this.getSeasonSelected();
        var queryCount = this.getSelectedKeywordQueryCountFilteredBySeason(keyword, seasonSelected);
        var queryCountString = queryCount.toLocaleString('en');
        if (!!seasonSelected) {
            var queryPctString = ((queryCount / keyword.queryCount) * 100).toLocaleString('en', {
                maximumSignificantDigits: 3
            });
            queryCountString += " (" + queryPctString + "%)";
        }
        return queryCountString;
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordTextNoResultsCountValue = function (keyword) {
        var queryCount = this.getSelectedKeywordQueryCountFilteredBySeason(keyword, this.getSeasonSelected());
        var noResultsCount = this.getSelectedKeywordNoResultsCountFilteredBySeason(keyword, this.getSeasonSelected());
        var noResultsPctString = ((noResultsCount / queryCount) * 100).toLocaleString('en', {
            maximumSignificantDigits: 3
        });
        return noResultsCount.toLocaleString('en') + " (" + noResultsPctString + "%)";
    };
    KeywordsDetailsComponent.prototype.updateRelatedQueriesGroupSelectedKeywordsListSeries = function (series) {
        var relatedQueriesGroupPositionX = this.getSelectedKeywordsListSerieRelatedQueriesGroupPositionX();
        var relatedQueriesGroupPositionY = this.getSelectedKeywordsListSerieRelatedQueriesGroupPositionY();
        var relatedQueriesGroup = series
            .select('.selected-keywords-serie__related-queries-group')
            .attr('transform', "translate(" + relatedQueriesGroupPositionX + ", " + relatedQueriesGroupPositionY + ")");
        relatedQueriesGroup
            .transition().duration(this.config.transitionsDurationInMillis)
            .style('opacity', this.getSelectedKeywordsListSerieRelatedQueriesGroupOpacity());
        var thisArg = this;
        relatedQueriesGroup.each(function (d) {
            var relatedQueries;
            if (d.relatedQueries) {
                relatedQueries = d.relatedQueries;
                thisArg.removeLoadingIconRelatedQueries(d.selectionOrder);
            }
            else {
                relatedQueries = thisArg.getLureRelatedQueries(d);
            }
            var relatedQueriesSeries = d3_selection_1.select(this)
                .selectAll('.related-queries-serie')
                .data(relatedQueries, function (dt) { return data_utils_1.getQueryId(dt); });
            thisArg.removeRelatedQueriesSeries(relatedQueriesSeries);
            thisArg.updateRelatedQueriesSeries(relatedQueriesSeries, d);
            thisArg.enterRelatedQueriesSeries(relatedQueriesSeries, d);
        });
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieRelatedQueriesGroupPositionX = function () {
        var groupPositionX = this.selectedKeywordMargin;
        if ((this.size.width >= KeywordsDetailsComponent.minWidthToShowKeywordGroupExpaded)) {
            groupPositionX += (this.getSelectedKeywordsListSerieKeywordContainerWidth(true) + (this.selectedKeywordPadding * 2));
        }
        return (groupPositionX + this.selectedKeywordPadding);
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieRelatedQueriesGroupPositionY = function () {
        var groupPositionY = ((this.size.width >= KeywordsDetailsComponent.minWidthToShowKeywordGroupExpaded) ? this.selectedKeywordMargin
            : KeywordsDetailsComponent.componentHeightCollapsed);
        return (groupPositionY + this.selectedKeywordPadding);
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieRelatedQueriesGroupOpacity = function () {
        return ((this.size.height > KeywordsDetailsComponent.componentHeightCollapsed) ? 1 : 0);
    };
    KeywordsDetailsComponent.prototype.removeRelatedQueriesSeries = function (series) {
        var exitSeries = series.exit();
        exitSeries
            .transition().duration(this.config.transitionsDurationInMillis)
            .style('opacity', 0);
        exitSeries
            .style('pointer-events', 'none')
            .transition().delay(this.config.transitionsDurationInMillis)
            .remove();
    };
    KeywordsDetailsComponent.prototype.updateRelatedQueriesSeries = function (series, keyword) {
        var _this = this;
        series
            .style('pointer-events', 'auto')
            .transition().duration(this.config.transitionsDurationInMillis)
            .style('opacity', 1);
        series
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('transform', function (d) { return "translate(0, " + _this.getRelatedQueriesSeriePositionY(d, keyword) + ")"; });
        this.updatePercentageChartGroupRelatedQueriesSeries(series, keyword);
    };
    KeywordsDetailsComponent.prototype.getRelatedQueriesSeriePositionY = function (query, keyword) {
        return data_utils_1.getIndexOfQuery(query, keyword.relatedQueries || this.getLureRelatedQueries(keyword))
            * (this.getRelatedQueriesSerieHeight() + this.selectedKeywordPadding);
    };
    KeywordsDetailsComponent.prototype.getRelatedQueriesSerieHeight = function () {
        return ((this.getSelectedKeywordsListSerieRelatedQueriesContainerHeight() / this.relatedQueriesToShow) - this.selectedKeywordPadding);
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieRelatedQueriesContainerHeight = function () {
        var containerHeight = (KeywordsDetailsComponent.relatedQueriesListHeight - this.selectedKeywordMargin);
        if ((this.size.width >= KeywordsDetailsComponent.minWidthToShowKeywordGroupExpaded)) {
            containerHeight -= this.selectedKeywordMargin;
        }
        return (containerHeight - this.selectedKeywordPadding);
    };
    KeywordsDetailsComponent.prototype.updatePercentageChartGroupRelatedQueriesSeries = function (series, keyword) {
        var _this = this;
        series
            .select('.related-queries-serie__percentage-chart-foreground')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('width', function (d) { return _this.getRelatedQueriesSerieQueryPercentageChartForegroundWidth(d, keyword); });
        series
            .select('.related-queries-serie__query-text--count-percentage')
            .text(function (d) { return _this.getRelatedQueriesSerieQueryPercentageChartTextCountPercentageValue(d, keyword); });
    };
    KeywordsDetailsComponent.prototype.getRelatedQueriesSerieQueryPercentageChartForegroundWidth = function (query, keyword) {
        return this.relatedQueriesPercentageChartScale(Math.min(this.getRelatedQueryCountPercentageFilteredBySeason(query, keyword, this.getSeasonSelected()), 1));
    };
    KeywordsDetailsComponent.prototype.getRelatedQueriesSerieQueryPercentageChartTextCountPercentageValue = function (query, keyword) {
        return (this.getRelatedQueryCountPercentageFilteredBySeason(query, keyword, this.getSeasonSelected()) * 100).toLocaleString('en', {
            maximumSignificantDigits: 3
        }) + "%";
    };
    KeywordsDetailsComponent.prototype.getRelatedQueryCountPercentageFilteredBySeason = function (query, keyword, season) {
        var keywordCount = this.getSelectedKeywordQueryCountFilteredBySeason(keyword, season);
        if (keywordCount > 0) {
            return (this.getQueryCountFilteredBySeason(query, season) / keywordCount);
        }
        return 0;
    };
    KeywordsDetailsComponent.prototype.getQueryCountFilteredBySeason = function (query, season) {
        if (!season) {
            return query.queryCount;
        }
        return d3_array_1.sum(query.distribution.filter(function (d) { return ((d.datetime >= season.startDate) && (d.datetime < season.endDate)); }), function (d) { return d.queryCount; });
    };
    KeywordsDetailsComponent.prototype.enterRelatedQueriesSeries = function (series, keyword) {
        var _this = this;
        var relatedQueriesLoadingOpacity = 0.2;
        var enterSeries = series.enter()
            .append('g')
            .attr('class', 'related-queries-serie')
            .style('opacity', relatedQueriesLoadingOpacity)
            .attr('transform', function (d) { return "translate(0, " + _this.getRelatedQueriesSeriePositionY(d, keyword) + ")"; });
        enterSeries
            .transition()
            .duration(this.config.transitionsDurationInMillis / 3)
            .style('opacity', keyword.relatedQueries ? 1 : relatedQueriesLoadingOpacity);
        var serieHeight = this.getRelatedQueriesSerieHeight();
        enterSeries
            .append('rect')
            .attr('class', 'related-queries-serie__container')
            .attr('width', this.getRelatedQueriesSerieWidth())
            .attr('height', serieHeight)
            .attr('rx', this.selectedKeywordContainerRadius)
            .attr('ry', this.selectedKeywordContainerRadius);
        var queryTextGroup = enterSeries
            .append('foreignObject')
            .attr('class', 'related-queries-serie__query-text-container')
            .attr('width', this.getRelatedQueriesSerieQueryPercentageChartGroupPositionX())
            .attr('height', serieHeight)
            .append('xhtml:div')
            .style('margin-left', this.selectedKeywordPadding)
            .style('margin-right', this.selectedKeywordPadding);
        queryTextGroup
            .append('xhtml:p')
            .attr('class', 'related-queries-serie__query-text related-queries-serie__query-text--terms')
            .text(function (d) { return d.terms; });
        this.enterPercentageChartGroupRelatedQueriesSeries(enterSeries, keyword);
    };
    KeywordsDetailsComponent.prototype.getRelatedQueriesSerieWidth = function () {
        return this.getSelectedKeywordsListSerieKeywordContainerWidth((this.size.width >= KeywordsDetailsComponent.minWidthToShowKeywordGroupExpaded));
    };
    KeywordsDetailsComponent.prototype.getRelatedQueriesSerieQueryPercentageChartGroupPositionX = function () {
        return (this.getRelatedQueriesSerieWidth() * (2 / 3));
    };
    KeywordsDetailsComponent.prototype.enterPercentageChartGroupRelatedQueriesSeries = function (enterSeries, keyword) {
        var _this = this;
        var percentageChartGroup = enterSeries
            .append('g')
            .attr('class', 'related-queries-serie__percentage-chart-group')
            .attr('transform', "translate(" + this.getRelatedQueriesSerieQueryPercentageChartGroupPositionX() + ", 0)");
        var percentageChartHeight = (this.getRelatedQueriesSerieHeight() - (this.selectedKeywordPadding * 2));
        percentageChartGroup
            .append('rect')
            .attr('class', 'related-queries-serie__percentage-chart-background')
            .attr('x', this.selectedKeywordPadding)
            .attr('y', this.selectedKeywordPadding)
            .attr('width', this.relatedQueriesPercentageChartScale.range()[1])
            .attr('height', percentageChartHeight)
            .attr('rx', this.selectedKeywordContainerRadius)
            .attr('ry', this.selectedKeywordContainerRadius);
        percentageChartGroup
            .append('rect')
            .attr('class', 'related-queries-serie__percentage-chart-foreground')
            .attr('x', this.selectedKeywordPadding)
            .attr('y', this.selectedKeywordPadding)
            .attr('width', function (d) { return _this.getRelatedQueriesSerieQueryPercentageChartForegroundWidth(d, keyword); })
            .attr('height', percentageChartHeight)
            .attr('rx', this.selectedKeywordContainerRadius)
            .attr('ry', this.selectedKeywordContainerRadius);
        var percentageTextHeight = 17;
        percentageChartGroup
            .append('text')
            .attr('class', 'related-queries-serie__query-text related-queries-serie__query-text--count-percentage')
            .attr('x', this.getRelatedQueriesSerieQueryPercentageChartTextPositionX())
            .attr('y', (this.getRelatedQueriesSerieHeight() / 2))
            .attr('dy', (percentageTextHeight / 4))
            .text(function (d) { return _this.getRelatedQueriesSerieQueryPercentageChartTextCountPercentageValue(d, keyword); });
    };
    KeywordsDetailsComponent.prototype.getRelatedQueriesSerieQueryPercentageChartTextPositionX = function () {
        return ((this.getRelatedQueriesSerieWidth() - this.getRelatedQueriesSerieQueryPercentageChartGroupPositionX()) / 2);
    };
    KeywordsDetailsComponent.prototype.enterSelectedKeywordsListSeries = function (series) {
        var _this = this;
        var enterSeries = series.enter()
            .append('g')
            .attr('class', function (d) { return _this.getSelectedKeywordsListSerieClass(d); });
        enterSeries
            .attr('transform', function (d) { return "translate(" + _this.getSelectedKeywordsListSeriePositionX(d.selectionOrder) + ", 0)"; })
            .style('opacity', 0)
            .transition().duration(this.config.transitionsDurationInMillis)
            .style('opacity', 1);
        this.enterKeywordGroupSelectedKeywordsListSeries(enterSeries);
        this.enterRelatedQueriesGroupSelectedKeywordsListSeries(enterSeries);
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieClass = function (keyword) {
        var baseSerieClass = 'selected-keywords-serie';
        var serieClass = baseSerieClass;
        serieClass += " " + baseSerieClass + "--" + keyword.selectionOrder;
        return serieClass;
    };
    KeywordsDetailsComponent.prototype.enterKeywordGroupSelectedKeywordsListSeries = function (enterSeries) {
        var _this = this;
        var keywordGroup = enterSeries
            .append('g')
            .attr('class', 'selected-keywords-serie__keyword-group')
            .attr('transform', function (d) { return "translate(" + _this.selectedKeywordMargin + ", " + _this.selectedKeywordMargin + ")"; });
        var isKeywordGroupExpanded = this.isKeywordGroupSelectedKeywordsListSeriesExpanded();
        keywordGroup
            .append('rect')
            .attr('class', 'selected-keywords-serie__keyword-container')
            .attr('x', this.selectedKeywordPadding)
            .attr('y', this.selectedKeywordPadding)
            .attr('width', this.getSelectedKeywordsListSerieKeywordContainerWidth(isKeywordGroupExpanded))
            .attr('height', this.getSelectedKeywordsListSerieKeywordContainerHeight(isKeywordGroupExpanded))
            .attr('rx', this.selectedKeywordContainerRadius)
            .attr('ry', this.selectedKeywordContainerRadius);
        this.enterKeywordChartGroupSelectedKeywordsListSeries(keywordGroup, isKeywordGroupExpanded);
        this.enterKeywordTextGroupSelectedKeywordsListSeries(keywordGroup, isKeywordGroupExpanded);
    };
    KeywordsDetailsComponent.prototype.enterKeywordChartGroupSelectedKeywordsListSeries = function (keywordGroup, isKeywordGroupExpanded) {
        var _this = this;
        Object.values(KpiEnum).forEach(function (kpi) {
            _this.enterKpiKeywordChartGroupSelectedKeywordsListSeries(kpi, keywordGroup, isKeywordGroupExpanded);
        });
    };
    KeywordsDetailsComponent.prototype.enterKpiKeywordChartGroupSelectedKeywordsListSeries = function (kpi, keywordGroup, isKeywordGroupExpanded) {
        var _this = this;
        var chartPositionX = this.getSelectedKeywordsListSerieKeywordKpiChartGroupCenterPositionX(kpi, isKeywordGroupExpanded);
        var chartPositionY = this.getSelectedKeywordsListSerieKeywordChartGroupCenterPositionY(isKeywordGroupExpanded);
        var keywordChartGroup = keywordGroup
            .append('g')
            .attr('class', "selected-keywords-serie__keyword-chart-group selected-keywords-serie__keyword-chart-group--" + kpi)
            .attr('transform', "translate(" + chartPositionX + ", " + chartPositionY + ")")
            .style('opacity', this.getSelectedKeywordsListSerieKeywordChartGroupOpacity(isKeywordGroupExpanded));
        keywordChartGroup
            .append('circle')
            .attr('class', 'selected-keywords-serie__keyword-chart-background')
            .attr('r', this.getSelectedKeywordsListSerieKeywordChartRadius(isKeywordGroupExpanded));
        keywordChartGroup
            .append('path')
            .attr('class', 'selected-keywords-serie__keyword-chart-foreground')
            .attr('d', function (d) { return _this.getSelectedKeywordsListSerieKeywordChartCommands(kpi, d, isKeywordGroupExpanded); });
        var keywordChartCenterGroup = keywordChartGroup
            .append('g')
            .attr('class', 'selected-keywords-serie__keyword-chart-center-group');
        var centerContainerRadius = this.getSelectedKeywordsListSerieKeywordChartCenterContainerRadius(isKeywordGroupExpanded);
        keywordChartCenterGroup
            .append('circle')
            .attr('class', 'selected-keywords-serie__keyword-chart-center-container')
            .attr('r', centerContainerRadius);
        var keywordChartCenterTextContainer = keywordChartCenterGroup
            .append('foreignObject')
            .attr('class', 'selected-keywords-serie__keyword-chart-text-container')
            .attr('x', -centerContainerRadius)
            .attr('y', -centerContainerRadius)
            .attr('height', (centerContainerRadius * 2))
            .attr('width', (centerContainerRadius * 2))
            .append('xhtml:div');
        keywordChartCenterTextContainer
            .append('xhtml:p')
            .attr('class', 'selected-keywords-serie__keyword-text selected-keywords-serie__keyword-text--count-description')
            .text(kpi);
        keywordChartCenterTextContainer
            .append('xhtml:p')
            .attr('class', 'selected-keywords-serie__keyword-text selected-keywords-serie__keyword-text--count-percentage')
            .text(function (d) { return _this.getSelectedKeywordsListSerieKeywordKpiChartTextCountPercentageValue(kpi, d); });
    };
    KeywordsDetailsComponent.prototype.getSelectedKeywordsListSerieKeywordChartCommands = function (kpi, keyword, isKeywordGroupExpanded) {
        var kpiPct = (_a = {},
            _a[KpiEnum.FINDABILITY] = this.getSelectedKeywordSuccessCountPercentageFilteredBySeason(keyword, this.getSeasonSelected()),
            _a[KpiEnum.ADD2CART] = this.getSelectedKeywordAdd2cartCountPercentageFilteredBySeason(keyword, this.getSeasonSelected()),
            _a)[kpi];
        var angle = this.selectedKeywordsSeasonChartScale(kpiPct);
        this.selectedKeywordsListSerieKeywordChartAnimationAnglesList[kpi][keyword.selectionOrder - 1] = angle;
        return this.getSelectedKeywordsListSerieKeywordChartCommandsGivenAngle(angle, isKeywordGroupExpanded);
        var _a;
    };
    KeywordsDetailsComponent.prototype.enterKeywordTextGroupSelectedKeywordsListSeries = function (keywordGroup, isKeywordGroupExpanded) {
        var _this = this;
        var keywordTextGroup = keywordGroup
            .append('foreignObject')
            .attr('class', 'selected-keywords-serie__keyword-text-container')
            .attr('x', this.selectedKeywordPadding)
            .attr('y', this.selectedKeywordPadding)
            .attr('width', this.getSelectedKeywordsListSerieKeywordContainerWidth(isKeywordGroupExpanded))
            .attr('height', this.getSelectedKeywordsListSerieKeywordTextContainerHeight(isKeywordGroupExpanded))
            .append('xhtml:div');
        keywordTextGroup
            .append('xhtml:p')
            .attr('class', 'selected-keywords-serie__keyword-text selected-keywords-serie__keyword-text--terms')
            .text(function (d) { return d.terms; });
        var keywordCountTextGroupParent = keywordTextGroup
            .append('xhtml:span')
            .attr('class', 'selected-keywords-serie__keyword-text-group selected-keywords-serie__keyword-text-group--parent');
        var keywordCountTextGroupChildQueries = keywordCountTextGroupParent
            .append('xhtml:p')
            .attr('class', 'selected-keywords-serie__keyword-text-group selected-keywords-serie__keyword-text-group--queries');
        keywordCountTextGroupChildQueries
            .append('xhtml:span')
            .attr('class', 'selected-keywords-serie__keyword-text selected-keywords-serie__keyword-text--count-description')
            .text('Queries: ');
        keywordCountTextGroupChildQueries
            .append('xhtml:span')
            .attr('class', 'selected-keywords-serie__keyword-text selected-keywords-serie__keyword-text--count-value')
            .text(function (d) { return _this.getSelectedKeywordsListSerieKeywordTextQueryCountValue(d); });
        var keywordCountTextGroupChildNoResults = keywordCountTextGroupParent
            .append('xhtml:p')
            .attr('class', 'selected-keywords-serie__keyword-text-group selected-keywords-serie__keyword-text-group--no-results');
        keywordCountTextGroupChildNoResults
            .append('xhtml:span')
            .attr('class', 'selected-keywords-serie__keyword-text selected-keywords-serie__keyword-text--count-description')
            .text('No results: ');
        keywordCountTextGroupChildNoResults
            .append('xhtml:span')
            .attr('class', 'selected-keywords-serie__keyword-text selected-keywords-serie__keyword-text--count-value')
            .text(function (d) { return _this.getSelectedKeywordsListSerieKeywordTextNoResultsCountValue(d); });
    };
    KeywordsDetailsComponent.prototype.enterRelatedQueriesGroupSelectedKeywordsListSeries = function (enterSeries) {
        var relatedQueriesClass = 'selected-keywords-serie__related-queries-group';
        var relatedQueriesGroupPositionX = this.getSelectedKeywordsListSerieRelatedQueriesGroupPositionX();
        var relatedQueriesGroupPositionY = this.getSelectedKeywordsListSerieRelatedQueriesGroupPositionY();
        var relatedQueriesGroup = enterSeries
            .append('g')
            .attr('class', relatedQueriesClass)
            .attr('transform', "translate(" + relatedQueriesGroupPositionX + ", " + relatedQueriesGroupPositionY + ")")
            .style('opacity', this.getSelectedKeywordsListSerieRelatedQueriesGroupOpacity());
        var thisArg = this;
        relatedQueriesGroup.each(function (d) {
            var relatedQueries;
            if (d.relatedQueries) {
                relatedQueries = d.relatedQueries;
            }
            else {
                relatedQueries = thisArg.getLureRelatedQueries(d);
                thisArg.displayLoadingIconRelatedQueries(relatedQueriesGroup);
            }
            var relatedQueriesSeries = d3_selection_1.select(this)
                .selectAll('.related-queries-serie')
                .data(relatedQueries, function (dt) { return data_utils_1.getQueryId(dt); });
            thisArg.removeRelatedQueriesSeries(relatedQueriesSeries);
            thisArg.updateRelatedQueriesSeries(relatedQueriesSeries, d);
            thisArg.enterRelatedQueriesSeries(relatedQueriesSeries, d);
        });
    };
    KeywordsDetailsComponent.prototype.displayLoadingIconRelatedQueries = function (relatedQueriesGroup) {
        var heightLoadingIcon = this.getSelectedKeywordsListSerieRelatedQueriesContainerHeight() / 3;
        var loadingIconContainer = relatedQueriesGroup
            .append('foreignObject')
            .classed('loading-container', true)
            .attr('y', heightLoadingIcon)
            .attr('width', this.getRelatedQueriesSerieWidth())
            .attr('height', heightLoadingIcon);
        loadingIconContainer
            .append('xhtml:div')
            .classed('loading-icon', true);
    };
    KeywordsDetailsComponent.prototype.removeLoadingIconRelatedQueries = function (keywordSelectionOrder) {
        d3_selection_1.select(".selected-keywords-serie--" + keywordSelectionOrder + " .selected-keywords-serie__related-queries-group")
            .select('.loading-container')
            .remove();
    };
    KeywordsDetailsComponent.prototype.resizeSelectedKeywordsList = function () {
        var _this = this;
        this.selectedKeywordsListElement
            .attr('height', this.size.height);
        this.resizeSelectedKeywordsContainers();
        var series = this.selectedKeywordsListElement
            .selectAll('.selected-keywords-serie')
            .attr('transform', function (d) { return "translate(" + _this.getSelectedKeywordsListSeriePositionX(d.selectionOrder) + ", 0)"; });
        this.resizeKeywordGroupSelectedKeywordsListSeries(series);
        this.resizeRelatedQueriesGroupSelectedKeywordsListSeries(series);
    };
    KeywordsDetailsComponent.prototype.resizeSelectedKeywordsContainers = function () {
        var selectedKeywordsListSerieWidth = this.getSelectedKeywordsListSerieWidth();
        var selectedKeywordsListSerieHeight = this.getSelectedKeywordsListSerieHeight();
        for (var selectionOrder = 1; selectionOrder <= this.config.maxKeywordsSelected; selectionOrder++) {
            this.selectedKeywordsListElement
                .select(".selected-keyword-container--" + selectionOrder)
                .attr('transform', "translate(" + this.getSelectedKeywordsListSeriePositionX(selectionOrder) + ", 0)")
                .attr('width', selectedKeywordsListSerieWidth)
                .attr('height', selectedKeywordsListSerieHeight);
        }
    };
    KeywordsDetailsComponent.prototype.resizeKeywordGroupSelectedKeywordsListSeries = function (series) {
        var isKeywordGroupExpanded = this.isKeywordGroupSelectedKeywordsListSeriesExpanded();
        series
            .select('.selected-keywords-serie__keyword-container')
            .attr('width', this.getSelectedKeywordsListSerieKeywordContainerWidth(isKeywordGroupExpanded))
            .attr('height', this.getSelectedKeywordsListSerieKeywordContainerHeight(isKeywordGroupExpanded));
        this.resizeKeywordChartGroupSelectedKeywordsListSeries(series, isKeywordGroupExpanded);
        this.resizeKeywordTextGroupSelectedKeywordsListSeries(series, isKeywordGroupExpanded);
    };
    KeywordsDetailsComponent.prototype.resizeKeywordChartGroupSelectedKeywordsListSeries = function (series, isKeywordGroupExpanded) {
        var _this = this;
        Object.values(KpiEnum).forEach(function (kpi) {
            _this.resizeKpiKeywordChartGroupSelectedKeywordsListSeries(kpi, series, isKeywordGroupExpanded);
        });
    };
    KeywordsDetailsComponent.prototype.resizeKpiKeywordChartGroupSelectedKeywordsListSeries = function (kpi, series, isKeywordGroupExpanded) {
        var _this = this;
        var chartPositionX = this.getSelectedKeywordsListSerieKeywordKpiChartGroupCenterPositionX(kpi, isKeywordGroupExpanded);
        var chartPositionY = this.getSelectedKeywordsListSerieKeywordChartGroupCenterPositionY(isKeywordGroupExpanded);
        var keywordChartGroup = series
            .select(".selected-keywords-serie__keyword-chart-group--" + kpi)
            .attr('transform', "translate(" + chartPositionX + ", " + chartPositionY + ")")
            .style('opacity', this.getSelectedKeywordsListSerieKeywordChartGroupOpacity(isKeywordGroupExpanded));
        keywordChartGroup
            .select('.selected-keywords-serie__keyword-chart-background')
            .attr('r', this.getSelectedKeywordsListSerieKeywordChartRadius(isKeywordGroupExpanded));
        keywordChartGroup
            .select('.selected-keywords-serie__keyword-chart-foreground')
            .attr('d', function (d) { return _this.getSelectedKeywordsListSerieKeywordChartCommands(kpi, d, isKeywordGroupExpanded); });
        var centerContainerRadius = this.getSelectedKeywordsListSerieKeywordChartCenterContainerRadius(isKeywordGroupExpanded);
        keywordChartGroup
            .select('.selected-keywords-serie__keyword-chart-center-container')
            .attr('r', centerContainerRadius);
        keywordChartGroup
            .select('.selected-keywords-serie__keyword-chart-text-container')
            .attr('x', -centerContainerRadius)
            .attr('y', -centerContainerRadius)
            .attr('height', (centerContainerRadius * 2))
            .attr('width', (centerContainerRadius * 2));
    };
    KeywordsDetailsComponent.prototype.resizeKeywordTextGroupSelectedKeywordsListSeries = function (series, isKeywordGroupExpanded) {
        series
            .select('.selected-keywords-serie__keyword-text-container')
            .attr('width', this.getSelectedKeywordsListSerieKeywordContainerWidth(isKeywordGroupExpanded))
            .attr('height', this.getSelectedKeywordsListSerieKeywordTextContainerHeight(isKeywordGroupExpanded));
    };
    KeywordsDetailsComponent.prototype.resizeRelatedQueriesGroupSelectedKeywordsListSeries = function (series) {
        var relatedQueriesGroupPositionX = this.getSelectedKeywordsListSerieRelatedQueriesGroupPositionX();
        var relatedQueriesGroupPositionY = this.getSelectedKeywordsListSerieRelatedQueriesGroupPositionY();
        var relatedQueriesGroup = series
            .select('.selected-keywords-serie__related-queries-group')
            .attr('transform', "translate(" + relatedQueriesGroupPositionX + ", " + relatedQueriesGroupPositionY + ")")
            .style('opacity', this.getSelectedKeywordsListSerieRelatedQueriesGroupOpacity());
        var heightLoadingIcon = this.getSelectedKeywordsListSerieRelatedQueriesContainerHeight() / 3;
        relatedQueriesGroup
            .select('.loading-container')
            .attr('y', heightLoadingIcon)
            .attr('width', this.getRelatedQueriesSerieWidth())
            .attr('height', heightLoadingIcon);
        var thisArg = this;
        relatedQueriesGroup.each(function (d) {
            var relatedQueriesSeries = d3_selection_1.select(this)
                .selectAll('.related-queries-serie');
            thisArg.resizeRelatedQueriesSeries(relatedQueriesSeries, d);
        });
    };
    KeywordsDetailsComponent.prototype.resizeRelatedQueriesSeries = function (series, keyword) {
        var _this = this;
        series
            .attr('transform', function (d) { return "translate(0, " + _this.getRelatedQueriesSeriePositionY(d, keyword) + ")"; });
        var serieHeight = this.getRelatedQueriesSerieHeight();
        series
            .select('.related-queries-serie__container')
            .attr('width', this.getRelatedQueriesSerieWidth())
            .attr('height', serieHeight);
        series
            .select('.related-queries-serie__query-text-container')
            .attr('width', this.getRelatedQueriesSerieQueryPercentageChartGroupPositionX())
            .attr('height', serieHeight);
        this.resizePercentageChartGroupRelatedQueriesSeries(series, keyword);
    };
    KeywordsDetailsComponent.prototype.resizePercentageChartGroupRelatedQueriesSeries = function (series, keyword) {
        var _this = this;
        series
            .select('.related-queries-serie__percentage-chart-group')
            .attr('transform', "translate(" + this.getRelatedQueriesSerieQueryPercentageChartGroupPositionX() + ", 0)");
        series
            .select('.related-queries-serie__percentage-chart-background')
            .attr('width', this.relatedQueriesPercentageChartScale.range()[1]);
        series
            .select('.related-queries-serie__percentage-chart-foreground')
            .attr('width', function (d) { return _this.getRelatedQueriesSerieQueryPercentageChartForegroundWidth(d, keyword); });
        series
            .select('.related-queries-serie__query-text--count-percentage')
            .attr('x', this.getRelatedQueriesSerieQueryPercentageChartTextPositionX())
            .attr('y', (this.getRelatedQueriesSerieHeight() / 2));
    };
    KeywordsDetailsComponent.componentHeightCollapsed = 90;
    KeywordsDetailsComponent.relatedQueriesListHeight = 270;
    KeywordsDetailsComponent.minWidthToShowKeywordGroupExpaded = 800;
    return KeywordsDetailsComponent;
}());
exports.KeywordsDetailsComponent = KeywordsDetailsComponent;
var KpiEnum;
(function (KpiEnum) {
    KpiEnum["FINDABILITY"] = "findability";
    KpiEnum["ADD2CART"] = "add2cart";
})(KpiEnum || (KpiEnum = {}));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(290);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(14)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/resolve-url-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?sourceMap!./keywords-details.component.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/resolve-url-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?sourceMap!./keywords-details.component.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(112);
exports = module.exports = __webpack_require__(13)(false);
// imports


// module
exports.push([module.i, ".keywords-details__selected-keywords-list {\n  display: block;\n  width: 100%;\n}\n\n.keywords-details__selected-keywords-list .selected-keyword-container {\n  fill: transparent;\n  opacity: 0.2;\n  transition-property: opacity;\n  transition-duration: 0.3s;\n}\n\n.keywords-details__selected-keywords-list .selected-keyword-container--selected {\n  opacity: 0.4;\n}\n\n.keywords-details__selected-keywords-list .selected-keyword-container--1 {\n  fill: #eab95c;\n}\n\n.keywords-details__selected-keywords-list .selected-keyword-container--2 {\n  fill: #89b9c1;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__keyword-container,\n.keywords-details__selected-keywords-list .selected-keywords-serie__keyword-chart-center-container {\n  fill: white;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__keyword-text-container div,\n.keywords-details__selected-keywords-list .selected-keywords-serie__keyword-chart-text-container div {\n  color: #81848b;\n  height: 100%;\n  padding: 4px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__keyword-text-container p,\n.keywords-details__selected-keywords-list .selected-keywords-serie__keyword-chart-text-container p {\n  margin: 1px 0;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__keyword-text-group--parent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__keyword-text-group--no-results {\n  color: #bd0b49;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__keyword-text {\n  max-width: 100%;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__keyword-text--count-percentage {\n  font-size: 16px;\n  text-anchor: middle;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__keyword-text--terms {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #414649;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__keyword-text--count-description,\n.keywords-details__selected-keywords-list .selected-keywords-serie__keyword-text--count-value {\n  font-size: 13px;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__keyword-text--count-description {\n  text-transform: capitalize;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__related-queries-group .related-queries-serie__container {\n  fill: white;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__related-queries-group .related-queries-serie__query-text-container div {\n  height: 100%;\n  padding: 4px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__related-queries-group .related-queries-serie__query-text {\n  max-width: 100%;\n  margin: 0;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__related-queries-group .related-queries-serie__query-text--terms {\n  color: #414649;\n  font-size: 15px;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__related-queries-group .related-queries-serie__query-text--count-percentage {\n  fill: white;\n  font-size: 12px;\n  text-anchor: middle;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie__related-queries-group .loading-container .loading-icon {\n  height: 100%;\n  background-image: url(" + escape(__webpack_require__(291)) + ");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie--1 .selected-keywords-serie__keyword-chart-background {\n  fill: rgba(234, 185, 92, 0.5);\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie--1 .selected-keywords-serie__keyword-chart-foreground {\n  fill: #eab95c;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie--1 .selected-keywords-serie__keyword-text--count-percentage {\n  fill: #eab95c;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie--1 .selected-keywords-serie__keyword-text--terms {\n  color: #eab95c;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie--1 .selected-keywords-serie__related-queries-group .related-queries-serie__percentage-chart-background {\n  fill: rgba(234, 185, 92, 0.7);\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie--1 .selected-keywords-serie__related-queries-group .related-queries-serie__percentage-chart-foreground {\n  fill: rgba(234, 185, 92, 0.9);\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie--2 .selected-keywords-serie__keyword-chart-background {\n  fill: rgba(137, 185, 193, 0.5);\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie--2 .selected-keywords-serie__keyword-chart-foreground {\n  fill: #89b9c1;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie--2 .selected-keywords-serie__keyword-text--count-percentage {\n  fill: #89b9c1;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie--2 .selected-keywords-serie__keyword-text--terms {\n  color: #89b9c1;\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie--2 .selected-keywords-serie__related-queries-group .related-queries-serie__percentage-chart-background {\n  fill: rgba(137, 185, 193, 0.7);\n}\n\n.keywords-details__selected-keywords-list .selected-keywords-serie--2 .selected-keywords-serie__related-queries-group .related-queries-serie__percentage-chart-foreground {\n  fill: rgba(137, 185, 193, 0.9);\n}", ""]);

// exports


/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var d3_array_1 = __webpack_require__(2);
var d3_scale_1 = __webpack_require__(38);
var d3_selection_1 = __webpack_require__(1);
var d3_shape_1 = __webpack_require__(48);
var details_component_enum_1 = __webpack_require__(56);
var performance_indicator_enum_1 = __webpack_require__(113);
var visualization_1 = __webpack_require__(57);
__webpack_require__(293);
var PeriodSelectorComponent = (function () {
    function PeriodSelectorComponent(componentHtmlElement, size, config, data, seasonsList) {
        this.componentHtmlElement = componentHtmlElement;
        this.size = size;
        this.config = config;
        this.data = data;
        this.seasonsList = seasonsList;
        this.componentTemplate = "\n    <svg class=\"period-selector__seasons-list\"></svg>\n  ";
        this.keywordsDistributionDatetimeScale = d3_scale_1.scaleTime();
        this.keywordsDistributionValueScale = d3_scale_1.scaleLinear();
        this.seasonWidthCollapsed = 45;
        this.keywordsDistributionTopMargin = 4;
        this.keywordsDistributionBottomMargin = 4;
        this.keywordsDistributionGroundMinHeight = 1;
        this.seasonPreviewTextFontSize = 14;
        this.seasonHeaderHeight = (PeriodSelectorComponent.componentHeightCollapsed / 2);
        this.seasonIconSize = (this.seasonHeaderHeight - 6);
        this.initializeComponent();
    }
    PeriodSelectorComponent.prototype.setConfig = function (config) {
        this.config = config;
        this.setChartsScalesRange();
        this.renderSeasonsList();
        this.updateMouseOverEffect();
    };
    PeriodSelectorComponent.prototype.setData = function (data) {
        this.data = data;
        this.setHoveredSeason();
        this.setChartsScalesDomain();
        this.setChartsScalesRange();
        this.renderSeasonsList();
        this.removeMouseOverEffect();
        this.initializeMouseOverEffect();
    };
    PeriodSelectorComponent.prototype.resize = function (size) {
        this.size = size;
        this.setChartsScalesRange();
        this.resizeSeasonsList();
    };
    PeriodSelectorComponent.prototype.setComponentHeight = function (componentHeight) {
        this.size.height = componentHeight;
    };
    PeriodSelectorComponent.prototype.setSeasonsList = function (seasonsList) {
        this.seasonsList = seasonsList;
        this.generateKeywordsDistributionDatetimeScalesBySeason();
    };
    PeriodSelectorComponent.prototype.onPeriodSelected = function (period) { };
    PeriodSelectorComponent.prototype.initializeComponent = function () {
        this.componentHtmlElement.innerHTML += this.componentTemplate;
        this.componentElement = d3_selection_1.select(this.componentHtmlElement)
            .classed('period-selector', true);
        this.seasonsListElement = this.componentElement
            .select('.period-selector__seasons-list')
            .attr('height', this.size.height);
        this.bisectDate = d3_array_1.bisector(function (d) { return d.datetime; }).left;
        this.generateKeywordsDistributionDatetimeScalesBySeason();
        this.setChartsScalesDomain();
        this.setChartsScalesRange();
        this.renderSeasonsList();
    };
    PeriodSelectorComponent.prototype.generateKeywordsDistributionDatetimeScalesBySeason = function () {
        var _this = this;
        this.keywordsDistributionDatetimeScalesBySeason = {};
        this.seasonsList.forEach(function (season) {
            _this.keywordsDistributionDatetimeScalesBySeason[season.order] = d3_scale_1.scaleTime();
        });
    };
    PeriodSelectorComponent.prototype.setChartsScalesRange = function () {
        var _this = this;
        var keywordsDistributionValueScaleMinRange = (this.size.height - this.getSeasonsListSerieDistributionGroundHeight());
        var keywordsDistributionValueScaleMaxRange = (this.seasonHeaderHeight + this.keywordsDistributionTopMargin);
        this.keywordsDistributionValueScale
            .range([keywordsDistributionValueScaleMinRange, keywordsDistributionValueScaleMaxRange]);
        this.keywordsDistributionDatetimeScale
            .range([0, this.size.width]);
        this.seasonsList.forEach(function (season) {
            var keywordsDistributionDatetimeSeasonScale = _this.keywordsDistributionDatetimeScalesBySeason[season.order];
            keywordsDistributionDatetimeSeasonScale
                .range([0, _this.getSeasonsListSerieWidth(season)]);
        });
    };
    PeriodSelectorComponent.prototype.getSeasonsListSerieDistributionGroundHeight = function () {
        return (this.isComponentCollapsed() ? this.keywordsDistributionGroundMinHeight : this.keywordsDistributionBottomMargin);
    };
    PeriodSelectorComponent.prototype.isComponentCollapsed = function () {
        return (!!this.config.expandedDetailsComponent && (this.config.expandedDetailsComponent !== details_component_enum_1.DetailsComponentEnum.PERIOD_SELECTOR));
    };
    PeriodSelectorComponent.prototype.getSeasonsListSerieWidth = function (season) {
        if (this.data.selectedKeywords.length > 0) {
            if (this.isSeasonSelected(season)) {
                return (this.size.width - (this.seasonWidthCollapsed * (this.seasonsList.length - 1)));
            }
            if (this.isAnySeasonSelected()) {
                return this.seasonWidthCollapsed;
            }
        }
        return (this.keywordsDistributionDatetimeScale(season.endDate) - this.keywordsDistributionDatetimeScale(season.startDate));
    };
    PeriodSelectorComponent.prototype.isAnySeasonSelected = function () {
        var _this = this;
        return this.seasonsList.some(function (d) { return _this.isSeasonSelected(d); });
    };
    PeriodSelectorComponent.prototype.isSeasonSelected = function (season) {
        if ((this.seasonsList.length > 1) && (!!this.config.selectedPeriod.startDate && !!this.config.selectedPeriod.endDate)) {
            return ((season.startDate.getTime() === this.config.selectedPeriod.startDate.getTime()) &&
                (season.endDate.getTime() === this.config.selectedPeriod.endDate.getTime()));
        }
        return false;
    };
    PeriodSelectorComponent.prototype.renderSeasonsList = function () {
        this.seasonsListElement
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('height', this.size.height);
        var seasonsSeries = this.seasonsListElement
            .selectAll('.seasons-serie')
            .data(this.seasonsList, function (d) { return d.startDate; });
        this.removeSeasonsListSeries(seasonsSeries);
        this.updateSeasonsListSeries(seasonsSeries);
        this.enterSeasonsListSeries(seasonsSeries);
    };
    PeriodSelectorComponent.prototype.removeSeasonsListSeries = function (series) {
        var exitSeries = series.exit();
        exitSeries
            .transition().duration(this.config.transitionsDurationInMillis)
            .style('opacity', 0);
        exitSeries
            .style('pointer-events', 'none')
            .transition().delay(this.config.transitionsDurationInMillis)
            .remove();
    };
    PeriodSelectorComponent.prototype.updateSeasonsListSeries = function (series) {
        var _this = this;
        series
            .attr('class', function (d, i) { return _this.getSeasonsListSerieClass(d, i); })
            .style('pointer-events', function () { return _this.getSeasonsListSeriePointerEvents(); })
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('transform', function (d, i) { return "translate(" + _this.getSeasonsListSeriePositionX(i) + ", 0)"; })
            .style('opacity', 1);
        var isAnyKeywordSelected = this.isAnyKeywordSelected();
        this.updateAnyKeywordSelectedGroupSeasonsListSeries(series, isAnyKeywordSelected);
        this.updateNoKeywordSelectedGroupSeasonsListSeries(series, isAnyKeywordSelected);
    };
    PeriodSelectorComponent.prototype.getSeasonsListSerieClass = function (season, seasonIndex) {
        var baseSerieClass = 'seasons-serie';
        var serieClass = baseSerieClass + " " + baseSerieClass + "--" + season.id + " " + baseSerieClass + "--" + seasonIndex;
        if (this.isSeasonHovered(season)) {
            serieClass += " " + baseSerieClass + "--hovered";
        }
        else {
            if (!!this.hoveredSeason) {
                serieClass += " " + baseSerieClass + "--not-hovered";
            }
        }
        if (this.isSeasonSelected(season)) {
            serieClass += " " + baseSerieClass + "--selected";
        }
        else {
            if (this.isAnySeasonSelected()) {
                serieClass += " " + baseSerieClass + "--not-selected";
            }
        }
        return serieClass;
    };
    PeriodSelectorComponent.prototype.isSeasonHovered = function (season) {
        return (!!this.hoveredSeason && (season.id === this.hoveredSeason.id));
    };
    PeriodSelectorComponent.prototype.getSeasonsListSeriePointerEvents = function () {
        return ((this.seasonsList.length > 1) ? 'auto' : 'none');
    };
    PeriodSelectorComponent.prototype.getSeasonsListSeriePositionX = function (index) {
        var seriePositionX = 0;
        for (var i = 0; i < index; i++) {
            seriePositionX += this.getSeasonsListSerieWidth(this.seasonsList[i]);
        }
        return seriePositionX;
    };
    PeriodSelectorComponent.prototype.isAnyKeywordSelected = function () {
        return (this.data.selectedKeywords.length > 0);
    };
    PeriodSelectorComponent.prototype.updateAnyKeywordSelectedGroupSeasonsListSeries = function (series, isAnyKeywordSelected) {
        var _this = this;
        if (isAnyKeywordSelected === void 0) { isAnyKeywordSelected = this.isAnyKeywordSelected(); }
        series
            .select('.seasons-serie__any-keyword-selected-group')
            .transition().duration(this.config.transitionsDurationInMillis)
            .style('opacity', (isAnyKeywordSelected ? 1 : 0));
        series
            .select('.seasons-serie__header')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('width', function (d) { return _this.getSeasonsListSerieWidth(d); });
        series
            .select('.seasons-serie__icon-container')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('x', function (d) { return _this.getSeasonsListSerieHeaderImagePositionX(d); });
        var _loop_1 = function (selectionOrder) {
            var selectedKeyword = this_1.data.selectedKeywords.find(function (d) { return (d.selectionOrder === selectionOrder); });
            series
                .select(".seasons-serie__distribution-chart-group--selected-keyword-" + selectionOrder)
                .transition().duration(this_1.config.transitionsDurationInMillis)
                .style('opacity', (!selectedKeyword ? 0 : 1));
            series
                .select(".seasons-serie__distribution-area--selected-keyword-" + selectionOrder)
                .attr('class', this_1.getSeasonsListSerieDistributionAreaClass(selectionOrder))
                .transition().duration(this_1.config.transitionsDurationInMillis)
                .attr('d', function (d) { return _this.getSeasonsListSerieDistributionAreaCommands(d, selectedKeyword); });
            series
                .select(".seasons-serie__distribution-line--selected-keyword-" + selectionOrder)
                .transition().duration(this_1.config.transitionsDurationInMillis)
                .attr('d', function (d) { return _this.getSeasonsListSerieDistributionLineCommands(d, selectedKeyword); });
        };
        var this_1 = this;
        for (var selectionOrder = 1; selectionOrder <= this.config.maxKeywordsSelected; selectionOrder++) {
            _loop_1(selectionOrder);
        }
        var distributionGroundPositionY = this.getSeasonsListSerieDistributionGroundPositionY();
        var distributionGroundHeight = this.getSeasonsListSerieDistributionGroundHeight();
        series
            .select('.seasons-serie__distribution-ground')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('y', distributionGroundPositionY)
            .attr('width', function (d) { return _this.getSeasonsListSerieWidth(d); })
            .attr('height', distributionGroundHeight);
    };
    PeriodSelectorComponent.prototype.getSeasonsListSerieHeaderImagePositionX = function (season) {
        return ((this.getSeasonsListSerieWidth(season) - this.seasonIconSize) / 2);
    };
    PeriodSelectorComponent.prototype.getSeasonsListSerieDistributionGroundPositionY = function () {
        return (this.size.height - this.getSeasonsListSerieDistributionGroundHeight());
    };
    PeriodSelectorComponent.prototype.updateNoKeywordSelectedGroupSeasonsListSeries = function (series, isAnyKeywordSelected) {
        var _this = this;
        if (isAnyKeywordSelected === void 0) { isAnyKeywordSelected = this.isAnyKeywordSelected(); }
        series
            .select('.seasons-serie__no-keyword-selected-group')
            .transition().duration(this.config.transitionsDurationInMillis)
            .style('opacity', (isAnyKeywordSelected ? 0 : 1));
        series
            .select('.seasons-serie__preview-background-container')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('width', function (d) { return _this.getSeasonsListSerieWidth(d); })
            .attr('height', this.size.height);
        series
            .select('.seasons-serie__preview-text-group')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('transform', function (d) { return _this.getSeasonsListSeriePreviewTextGroupTranslate(d, isAnyKeywordSelected); });
        series
            .select('.seasons-serie__preview-bubble')
            .transition().duration(this.config.transitionsDurationInMillis)
            .attr('r', function (d) { return _this.getSeasonsListSeriePreviewBubbleRadius(d, isAnyKeywordSelected); });
        series
            .select('.seasons-serie__preview-text')
            .transition().duration(this.config.transitionsDurationInMillis)
            .style('font-size', this.getSeasonsListSeriePreviewTextFontSize(isAnyKeywordSelected));
    };
    PeriodSelectorComponent.prototype.getSeasonsListSeriePreviewTextGroupTranslate = function (season, isAnyKeywordSelected) {
        var groupPositionX = (this.getSeasonsListSerieWidth(season) / 2);
        var groupPositionY;
        if (isAnyKeywordSelected) {
            groupPositionY = (this.seasonHeaderHeight / 2);
        }
        else {
            groupPositionY = (this.size.height / 2);
        }
        return "translate(" + groupPositionX + ", " + groupPositionY + ")";
    };
    PeriodSelectorComponent.prototype.getSeasonsListSeriePreviewBubbleRadius = function (season, isAnyKeywordSelected) {
        var bubbleRadius;
        if (isAnyKeywordSelected) {
            bubbleRadius = this.seasonIconSize;
        }
        else {
            bubbleRadius = (this.getSeasonsListSerieWidth(season) / 3);
            bubbleRadius = Math.min(bubbleRadius, 80);
            bubbleRadius = Math.max(bubbleRadius, 40);
        }
        return bubbleRadius;
    };
    PeriodSelectorComponent.prototype.getSeasonsListSeriePreviewTextFontSize = function (isAnyKeywordSelected) {
        return (isAnyKeywordSelected ? 0 : this.seasonPreviewTextFontSize);
    };
    PeriodSelectorComponent.prototype.enterSeasonsListSeries = function (series) {
        var _this = this;
        var enterSeries = series.enter()
            .append('g')
            .attr('class', function (d, i) { return _this.getSeasonsListSerieClass(d, i); })
            .on('mouseover', function (d) { return _this.onSeasonMouseOver(d); })
            .on('mouseout', function () { return _this.onSeasonMouseOut(); })
            .on('click', function (d) { return _this.onSeasonClick(d); });
        enterSeries
            .style('pointer-events', function () { return _this.getSeasonsListSeriePointerEvents(); })
            .attr('transform', function (d, i) { return "translate(" + _this.getSeasonsListSeriePositionX(i) + ", 0)"; })
            .style('opacity', 0)
            .transition().duration(this.config.transitionsDurationInMillis)
            .style('opacity', 1);
        var isAnyKeywordSelected = this.isAnyKeywordSelected();
        this.enterAnyKeywordSelectedGroupSeasonsListSeries(enterSeries, isAnyKeywordSelected);
        this.enterNoKeywordSelectedGroupSeasonsListSeries(enterSeries, isAnyKeywordSelected);
    };
    PeriodSelectorComponent.prototype.onSeasonMouseOver = function (season) {
        if (visualization_1.Visualization.checkTouchSupport()) {
            return;
        }
        this.setHoveredSeason(season);
    };
    PeriodSelectorComponent.prototype.setHoveredSeason = function (season) {
        var _this = this;
        this.hoveredSeason = season;
        this.seasonsListElement
            .selectAll('.seasons-serie')
            .attr('class', function (d, i) { return _this.getSeasonsListSerieClass(d, i); });
    };
    PeriodSelectorComponent.prototype.onSeasonMouseOut = function () {
        if (visualization_1.Visualization.checkTouchSupport()) {
            return;
        }
        this.setHoveredSeason();
    };
    PeriodSelectorComponent.prototype.onSeasonClick = function (season) {
        if (this.isSeasonSelected(season)) {
            this.onPeriodSelected({});
        }
        else {
            this.onPeriodSelected({
                startDate: season.startDate,
                endDate: season.endDate
            });
        }
    };
    PeriodSelectorComponent.prototype.enterAnyKeywordSelectedGroupSeasonsListSeries = function (enterSeries, isAnyKeywordSelected) {
        var _this = this;
        if (isAnyKeywordSelected === void 0) { isAnyKeywordSelected = this.isAnyKeywordSelected(); }
        var anyKeywordSelectedGroup = enterSeries
            .append('g')
            .attr('class', 'seasons-serie__any-keyword-selected-group')
            .style('opacity', (isAnyKeywordSelected ? 1 : 0));
        anyKeywordSelectedGroup
            .append('rect')
            .attr('class', 'seasons-serie__header')
            .attr('width', function (d) { return _this.getSeasonsListSerieWidth(d); })
            .attr('height', this.seasonHeaderHeight);
        anyKeywordSelectedGroup
            .append('foreignObject')
            .attr('class', 'seasons-serie__icon-container')
            .attr('x', function (d) { return _this.getSeasonsListSerieHeaderImagePositionX(d); })
            .attr('y', ((this.seasonHeaderHeight - this.seasonIconSize) / 2))
            .attr('width', this.seasonIconSize)
            .attr('height', this.seasonIconSize)
            .attr('transform', 'translate(0,0)')
            .append('xhtml:div')
            .attr('class', 'seasons-serie__icon');
        var _loop_2 = function (selectionOrder) {
            var selectedKeyword = this_2.data.selectedKeywords.find(function (d) { return (d.selectionOrder === selectionOrder); });
            var distributionChartGroup = anyKeywordSelectedGroup
                .append('g')
                .attr('class', "seasons-serie__distribution-chart-group seasons-serie__distribution-chart-group--selected-keyword-" + selectionOrder)
                .style('opacity', (!selectedKeyword ? 0 : 1));
            distributionChartGroup
                .append('path')
                .attr('class', this_2.getSeasonsListSerieDistributionAreaClass(selectionOrder))
                .attr('d', function (d) { return _this.getSeasonsListSerieDistributionAreaCommands(d, selectedKeyword); });
            distributionChartGroup
                .append('path')
                .attr('class', "seasons-serie__distribution-line seasons-serie__distribution-line--selected-keyword-" + selectionOrder)
                .attr('d', function (d) { return _this.getSeasonsListSerieDistributionLineCommands(d, selectedKeyword); });
        };
        var this_2 = this;
        for (var selectionOrder = 1; selectionOrder <= this.config.maxKeywordsSelected; selectionOrder++) {
            _loop_2(selectionOrder);
        }
        var distributionGroundPositionY = this.getSeasonsListSerieDistributionGroundPositionY();
        var distributionGroundHeight = this.getSeasonsListSerieDistributionGroundHeight();
        anyKeywordSelectedGroup
            .append('rect')
            .attr('class', 'seasons-serie__distribution-ground')
            .attr('y', distributionGroundPositionY)
            .attr('width', function (d) { return _this.getSeasonsListSerieWidth(d); })
            .attr('height', distributionGroundHeight);
    };
    PeriodSelectorComponent.prototype.enterNoKeywordSelectedGroupSeasonsListSeries = function (enterSeries, isAnyKeywordSelected) {
        var _this = this;
        if (isAnyKeywordSelected === void 0) { isAnyKeywordSelected = this.isAnyKeywordSelected(); }
        var noKeywordSelectedGroup = enterSeries
            .append('g')
            .attr('class', 'seasons-serie__no-keyword-selected-group')
            .style('opacity', (isAnyKeywordSelected ? 0 : 1));
        noKeywordSelectedGroup
            .append('foreignObject')
            .attr('class', 'seasons-serie__preview-background-container')
            .attr('width', function (d) { return _this.getSeasonsListSerieWidth(d); })
            .attr('height', this.size.height)
            .attr('transform', 'translate(0,0)')
            .append('xhtml:div')
            .attr('class', 'seasons-serie__preview-background');
        var previewTextGroup = noKeywordSelectedGroup
            .append('g')
            .attr('class', 'seasons-serie__preview-text-group')
            .attr('transform', function (d) { return _this.getSeasonsListSeriePreviewTextGroupTranslate(d, isAnyKeywordSelected); });
        previewTextGroup
            .append('circle')
            .attr('class', 'seasons-serie__preview-bubble')
            .attr('r', function (d) { return _this.getSeasonsListSeriePreviewBubbleRadius(d, isAnyKeywordSelected); });
        previewTextGroup
            .append('text')
            .attr('class', 'seasons-serie__preview-text')
            .text(function (d) { return d.id.toString().toUpperCase(); })
            .style('font-size', this.getSeasonsListSeriePreviewTextFontSize(isAnyKeywordSelected))
            .attr('dy', 6);
    };
    PeriodSelectorComponent.prototype.setChartsScalesDomain = function () {
        var _this = this;
        this.keywordsDistributionDatetimeScale
            .domain([this.seasonsList[0].startDate, this.seasonsList[this.seasonsList.length - 1].endDate]);
        this.seasonsList.forEach(function (season) {
            var keywordsDistributionDatetimeScale = _this.keywordsDistributionDatetimeScalesBySeason[season.order];
            keywordsDistributionDatetimeScale
                .domain([season.startDate, season.endDate]);
        });
        this.keywordsDistributionValueScale
            .domain([0, this.calculateMaxValueDistribution()]);
    };
    PeriodSelectorComponent.prototype.getSeasonsListSerieDistributionAreaClass = function (selectionOrder) {
        var baseSerieClass = 'seasons-serie__distribution-area';
        var serieClass = baseSerieClass;
        serieClass += " " + baseSerieClass + "--selected-keyword-" + selectionOrder;
        if (this.data.selectedKeywords.length === 1) {
            serieClass += " " + baseSerieClass + "--filled";
        }
        return serieClass;
    };
    PeriodSelectorComponent.prototype.getSeasonsListSerieDistributionAreaCommands = function (season, selectedKeyword) {
        if (!selectedKeyword) {
            return this.getSeasonsListSerieDistributionAreaInitialCommands(season);
        }
        return this.getSeasonsListSerieDistributionAreaSelectedKeywordCommands(season, selectedKeyword);
    };
    PeriodSelectorComponent.prototype.getSeasonsListSerieDistributionAreaInitialCommands = function (season) {
        var keywordsDistributionDatetimeScale = this.keywordsDistributionDatetimeScalesBySeason[season.order];
        var distributionArea = d3_shape_1.area()
            .curve(d3_shape_1.curveMonotoneX)
            .x(function (d) { return keywordsDistributionDatetimeScale(d); })
            .y0(this.keywordsDistributionValueScale.range()[0])
            .y1(this.keywordsDistributionValueScale.range()[0] - this.keywordsDistributionBottomMargin);
        return distributionArea(this.generateDatesSeasonArray(season));
    };
    PeriodSelectorComponent.prototype.generateDatesSeasonArray = function (season) {
        var startDateFullPeriod;
        var endDateFullPeriod;
        var keyword = (this.data.selectedKeywords[0] || this.data.keywords[0]);
        if (!!keyword) {
            startDateFullPeriod = d3_array_1.min(keyword.distribution, function (d) { return d.datetime; });
            endDateFullPeriod = d3_array_1.max(keyword.distribution, function (d) { return d.datetime; });
        }
        if (!startDateFullPeriod || (startDateFullPeriod < season.startDate)) {
            startDateFullPeriod = season.startDate;
        }
        if (!endDateFullPeriod || (endDateFullPeriod > season.endDate)) {
            endDateFullPeriod = season.endDate;
        }
        var dateSeasonArray = [];
        var dateSeason = new Date(startDateFullPeriod.getTime());
        while (dateSeason <= endDateFullPeriod) {
            dateSeasonArray.push(new Date(dateSeason.getTime()));
            dateSeason.setUTCDate(dateSeason.getUTCDate() + 1);
        }
        return dateSeasonArray;
    };
    PeriodSelectorComponent.prototype.getSeasonsListSerieDistributionAreaSelectedKeywordCommands = function (season, selectedKeyword) {
        var _this = this;
        var keywordsDistributionDatetimeScale = this.keywordsDistributionDatetimeScalesBySeason[season.order];
        var distributionArea = d3_shape_1.area()
            .curve(d3_shape_1.curveMonotoneX)
            .x(function (d) { return keywordsDistributionDatetimeScale(d.datetime); })
            .y0(this.size.height)
            .y1(function (d) { return _this.keywordsDistributionValueScale(_this.getKeywordValueOfDistribution(d)); });
        return distributionArea(this.getKeywordDistributionDataFilteredBySeason(selectedKeyword, season));
    };
    PeriodSelectorComponent.prototype.getKeywordValueOfDistribution = function (distributionItem) {
        switch (this.config.selectedPerformanceIndicator) {
            case performance_indicator_enum_1.PerformanceIndicatorEnum.CLICK_RATIO:
                return (distributionItem.clickCount / distributionItem.queryCount);
            case performance_indicator_enum_1.PerformanceIndicatorEnum.ADD2CART_RATIO:
                return (distributionItem.add2cartCount / distributionItem.queryCount);
            case performance_indicator_enum_1.PerformanceIndicatorEnum.NO_RESULTS_COUNT:
                return distributionItem.noResultsCount;
            case performance_indicator_enum_1.PerformanceIndicatorEnum.QUERY_COUNT:
            default:
                return distributionItem.queryCount;
        }
    };
    PeriodSelectorComponent.prototype.getKeywordDistributionDataFilteredBySeason = function (keyword, season) {
        return keyword.distribution.filter(function (d) { return ((d.datetime >= season.startDate) && (d.datetime <= season.endDate)); });
    };
    PeriodSelectorComponent.prototype.getSeasonsListSerieDistributionLineCommands = function (season, selectedKeyword) {
        if (!selectedKeyword) {
            return this.getSeasonsListSerieDistributionLineInitialCommands(season);
        }
        return this.getSeasonsListSerieDistributionLineSelectedKeywordCommands(season, selectedKeyword);
    };
    PeriodSelectorComponent.prototype.getSeasonsListSerieDistributionLineInitialCommands = function (season) {
        var keywordsDistributionDatetimeScale = this.keywordsDistributionDatetimeScalesBySeason[season.order];
        var distributionLine = d3_shape_1.line()
            .curve(d3_shape_1.curveMonotoneX)
            .x(function (d) { return keywordsDistributionDatetimeScale(d); })
            .y(this.keywordsDistributionValueScale.range()[0] - this.keywordsDistributionBottomMargin);
        return distributionLine(this.generateDatesSeasonArray(season));
    };
    PeriodSelectorComponent.prototype.getSeasonsListSerieDistributionLineSelectedKeywordCommands = function (season, selectedKeyword) {
        var _this = this;
        var keywordsDistributionDatetimeScale = this.keywordsDistributionDatetimeScalesBySeason[season.order];
        var distributionLine = d3_shape_1.line()
            .curve(d3_shape_1.curveMonotoneX)
            .x(function (d) { return keywordsDistributionDatetimeScale(d.datetime); })
            .y(function (d) { return _this.keywordsDistributionValueScale(_this.getKeywordValueOfDistribution(d)); });
        return distributionLine(this.getKeywordDistributionDataFilteredBySeason(selectedKeyword, season));
    };
    PeriodSelectorComponent.prototype.resizeSeasonsList = function () {
        var _this = this;
        this.seasonsListElement
            .attr('height', this.size.height);
        var series = this.seasonsListElement
            .selectAll('.seasons-serie')
            .attr('transform', function (d, i) { return "translate(" + _this.getSeasonsListSeriePositionX(i) + ", 0)"; });
        var isAnyKeywordSelected = this.isAnyKeywordSelected();
        series
            .select('.seasons-serie__header')
            .attr('width', function (d) { return _this.getSeasonsListSerieWidth(d); });
        series
            .select('.seasons-serie__icon-container')
            .attr('x', function (d) { return _this.getSeasonsListSerieHeaderImagePositionX(d); });
        var _loop_3 = function (selectionOrder) {
            var selectedKeyword = this_3.data.selectedKeywords.find(function (d) { return (d.selectionOrder === selectionOrder); });
            series
                .select(".seasons-serie__distribution-area--selected-keyword-" + selectionOrder)
                .attr('d', function (d) { return _this.getSeasonsListSerieDistributionAreaCommands(d, selectedKeyword); });
            series
                .select(".seasons-serie__distribution-line--selected-keyword-" + selectionOrder)
                .attr('d', function (d) { return _this.getSeasonsListSerieDistributionLineCommands(d, selectedKeyword); });
        };
        var this_3 = this;
        for (var selectionOrder = 1; selectionOrder <= this.config.maxKeywordsSelected; selectionOrder++) {
            _loop_3(selectionOrder);
        }
        var distributionGroundPositionY = this.getSeasonsListSerieDistributionGroundPositionY();
        series
            .select('.seasons-serie__distribution-ground')
            .attr('y', distributionGroundPositionY)
            .attr('width', function (d) { return _this.getSeasonsListSerieWidth(d); });
        series
            .select('.seasons-serie__preview-background-container')
            .attr('width', function (d) { return _this.getSeasonsListSerieWidth(d); })
            .attr('height', this.size.height);
        series
            .select('.seasons-serie__preview-text-group')
            .attr('transform', function (d) { return _this.getSeasonsListSeriePreviewTextGroupTranslate(d, isAnyKeywordSelected); });
        series
            .select('.seasons-serie__preview-bubble')
            .attr('r', function (d) { return _this.getSeasonsListSeriePreviewBubbleRadius(d, isAnyKeywordSelected); });
    };
    PeriodSelectorComponent.prototype.calculateMaxValueDistribution = function () {
        var _this = this;
        return d3_array_1.max(this.data.selectedKeywords, function (selectedKeyword) {
            return d3_array_1.max(selectedKeyword.distribution, function (dist) {
                return _this.getKeywordValueOfDistribution(dist);
            });
        });
    };
    PeriodSelectorComponent.prototype.updateMouseOverEffect = function () {
        var _this = this;
        var mouseOverLayoutClass = 'seasons-serie__mouse-over-layout';
        var anySeasonSelected = this.isAnySeasonSelected();
        this.seasonsList.forEach(function (season) {
            var seasonMouseOverGroup = _this.seasonsListElement
                .select(".seasons-serie--" + [season.order] + " ." + mouseOverLayoutClass);
            (!_this.isSeasonSelected(season) && anySeasonSelected)
                ? seasonMouseOverGroup.style('visibility', 'hidden')
                : seasonMouseOverGroup.style('visibility', 'visible');
            _this.resizeCatcherContainerRect(mouseOverLayoutClass, seasonMouseOverGroup, season);
        });
    };
    PeriodSelectorComponent.prototype.initializeMouseOverEffect = function () {
        var _this = this;
        var mouseOverLayoutClass = 'seasons-serie__mouse-over-layout';
        if (this.isAnyKeywordSelected()) {
            this.seasonsList.forEach(function (season) {
                var seasonMouseOverGroup = _this.seasonsListElement
                    .select(".seasons-serie--" + [season.order])
                    .append('g')
                    .classed(mouseOverLayoutClass, true)
                    .style('opacity', 0);
                _this.setVerticalLineMouseOverEffect(mouseOverLayoutClass, seasonMouseOverGroup);
                _this.setDateLabelMouseOverEffect(mouseOverLayoutClass, seasonMouseOverGroup);
                _this.setMouseLinesMouseOverEffect(mouseOverLayoutClass, seasonMouseOverGroup);
                _this.setCatcherContainerMouseOverEffect(mouseOverLayoutClass, seasonMouseOverGroup, season);
            });
            this.updateMouseOverEffect();
        }
    };
    PeriodSelectorComponent.prototype.removeMouseOverEffect = function () {
        this.seasonsListElement
            .selectAll('.seasons-serie__mouse-over-layout')
            .remove();
    };
    PeriodSelectorComponent.prototype.setVerticalLineMouseOverEffect = function (mouseOverLayoutClass, seasonMouseOverGroup) {
        seasonMouseOverGroup
            .append('path')
            .classed(mouseOverLayoutClass + "_vertical-line", true)
            .attr('transform', "translate(0," + ((this.seasonHeaderHeight - PeriodSelectorComponent.MOUSE_LINE_LABEL_HEIGHT) / 2 + 5) + ")");
    };
    PeriodSelectorComponent.prototype.setDateLabelMouseOverEffect = function (mouseOverLayoutClass, seasonMouseOverGroup) {
        var dateLabel = seasonMouseOverGroup
            .append('g')
            .classed(mouseOverLayoutClass + "_date-label", true);
        dateLabel.append('rect')
            .attr('height', PeriodSelectorComponent.MOUSE_LINE_LABEL_HEIGHT)
            .attr('width', PeriodSelectorComponent.MOUSE_LINE_DATE_LABEL_WIDTH)
            .attr('rx', 5)
            .attr('ry', 5);
        dateLabel.append('text')
            .attr('x', PeriodSelectorComponent.MOUSE_LINE_DATE_LABEL_WIDTH / 2)
            .attr('y', (PeriodSelectorComponent.MOUSE_LINE_LABEL_HEIGHT / 2) + 5);
    };
    PeriodSelectorComponent.prototype.setMouseLinesMouseOverEffect = function (mouseOverLayoutClass, seasonMouseOverGroup) {
        var mouseLineClass = mouseOverLayoutClass + "_mouse-line";
        var mousePerLine = seasonMouseOverGroup
            .selectAll("." + mouseLineClass)
            .data(this.data.selectedKeywords)
            .enter()
            .append('g')
            .classed("" + mouseLineClass, true);
        this.setCircleLabelMouseLines(mouseLineClass, mousePerLine);
        this.setValueLabelMouseLines(mouseLineClass, mousePerLine);
    };
    PeriodSelectorComponent.prototype.setCircleLabelMouseLines = function (mouseLineClass, mousePerLine) {
        var circleRadius = 10;
        var circleGroup = mousePerLine.append('g')
            .classed(mouseLineClass + "_circle-label", true);
        circleGroup.append('circle')
            .attr('class', function (d) { return mouseLineClass + "_circle-label-" + d.selectionOrder; })
            .attr('r', circleRadius);
    };
    PeriodSelectorComponent.prototype.setValueLabelMouseLines = function (mouseLineClass, mousePerLine) {
        var valueGroup = mousePerLine.append('g')
            .classed(mouseLineClass + "_value-label", true);
        valueGroup.append('rect')
            .attr('class', function (d) { return mouseLineClass + "_value-label-" + d.selectionOrder; })
            .attr('height', PeriodSelectorComponent.MOUSE_LINE_LABEL_HEIGHT)
            .attr('width', PeriodSelectorComponent.MOUSE_LINE_VALUE_LABEL_WIDTH)
            .attr('rx', 5)
            .attr('ry', 5);
        valueGroup.append('text')
            .attr('x', PeriodSelectorComponent.MOUSE_LINE_VALUE_LABEL_WIDTH / 2)
            .attr('y', (PeriodSelectorComponent.MOUSE_LINE_LABEL_HEIGHT / 2) + 5);
    };
    PeriodSelectorComponent.prototype.setCatcherContainerMouseOverEffect = function (mouseOverLayoutClass, seasonMouseOverGroup, season) {
        var _this = this;
        var catcherContainer = seasonMouseOverGroup
            .append('rect')
            .attr('class', mouseOverLayoutClass + "_mouse-container");
        this.resizeCatcherContainerRect(mouseOverLayoutClass, seasonMouseOverGroup, season);
        catcherContainer
            .on('mouseover', function () {
            seasonMouseOverGroup.style('opacity', 1);
            _this.handlerMoveEvent(mouseOverLayoutClass, seasonMouseOverGroup, season);
        })
            .on('mouseout', function () { return seasonMouseOverGroup.style('opacity', 0); })
            .on('mousemove', function () { return _this.handlerMoveEvent(mouseOverLayoutClass, seasonMouseOverGroup, season); });
        catcherContainer
            .on('touchstart', function () {
            seasonMouseOverGroup.style('opacity', 1);
            _this.handlerMoveEvent(mouseOverLayoutClass, seasonMouseOverGroup, season);
        })
            .on('touchend', function () { return seasonMouseOverGroup.style('opacity', 0); })
            .on('touchmove', function () { return _this.handlerMoveEvent(mouseOverLayoutClass, seasonMouseOverGroup, season); });
    };
    PeriodSelectorComponent.prototype.resizeCatcherContainerRect = function (mouseOverLayoutClass, seasonMouseOverGroup, season) {
        seasonMouseOverGroup
            .select("." + mouseOverLayoutClass + "_mouse-container")
            .attr('width', this.getSeasonsListSerieWidth(season))
            .attr('height', this.size.height);
    };
    PeriodSelectorComponent.prototype.handlerMoveEvent = function (mouseOverLayoutClass, seasonMouseOverGroup, season) {
        var _this = this;
        var xScaleSeason = this.keywordsDistributionDatetimeScalesBySeason[season.order];
        var x0Date = xScaleSeason.invert(d3_selection_1.mouse(document.querySelector(".seasons-serie--" + [season.order] + " ." + mouseOverLayoutClass + "_mouse-container"))[0]);
        var indexDistributionItem = this.bisectDate(this.data.selectedKeywords[0].distribution, x0Date, 1);
        var firstDistributionItem = this.data.selectedKeywords[0].distribution[indexDistributionItem - 1];
        var lastDistributionItem = this.data.selectedKeywords[0].distribution[indexDistributionItem];
        if (!!firstDistributionItem && !!lastDistributionItem) {
            var closeDistributionItem_1 = x0Date.getTime() - firstDistributionItem.datetime.getTime() > lastDistributionItem.datetime.getTime() - x0Date.getTime()
                ? lastDistributionItem : firstDistributionItem;
            seasonMouseOverGroup
                .select("." + mouseOverLayoutClass + "_vertical-line")
                .attr('d', function () { return "M" + xScaleSeason(closeDistributionItem_1.datetime) + ",\n          " + (_this.size.height - 5) + " " + xScaleSeason(closeDistributionItem_1.datetime) + ",0"; });
            this.handlerMoveEventDateLabel(mouseOverLayoutClass, seasonMouseOverGroup, season, closeDistributionItem_1.datetime);
            this.handlerMoveEventMouseLines(mouseOverLayoutClass, seasonMouseOverGroup, season, closeDistributionItem_1.datetime);
        }
    };
    PeriodSelectorComponent.prototype.handlerMoveEventDateLabel = function (mouseOverLayoutClass, seasonMouseOverGroup, season, closeDate) {
        var xScaleSeason = this.keywordsDistributionDatetimeScalesBySeason[season.order];
        var dateLabel = seasonMouseOverGroup
            .select("." + mouseOverLayoutClass + "_date-label");
        var xScaleDatePosition = xScaleSeason(closeDate);
        var xScaleWidth = xScaleSeason.range()[1];
        var splitDate = closeDate.toString().split(' ');
        dateLabel.select('text')
            .text(splitDate[0] + ", " + splitDate[2] + " " + splitDate[1]);
        var yPositionDateLabel = (this.seasonHeaderHeight - PeriodSelectorComponent.MOUSE_LINE_LABEL_HEIGHT) / 2;
        dateLabel
            .attr('transform', function () { return ((xScaleWidth / 2) < xScaleDatePosition)
            ? "translate(" + (xScaleDatePosition - PeriodSelectorComponent.MOUSE_LINE_DATE_LABEL_WIDTH + 5) + "," + yPositionDateLabel + ")"
            : "translate(" + (xScaleDatePosition - 5) + "," + yPositionDateLabel + ")"; });
    };
    PeriodSelectorComponent.prototype.handlerMoveEventMouseLines = function (mouseOverLayoutClass, seasonMouseOverGroup, season, closeDate) {
        var _this = this;
        var xScaleSeason = this.keywordsDistributionDatetimeScalesBySeason[season.order];
        var mouseLines = seasonMouseOverGroup
            .selectAll("." + mouseOverLayoutClass + "_mouse-line");
        var xScaleDatePosition = xScaleSeason(closeDate);
        var xScaleWidth = xScaleSeason.range()[1];
        mouseLines
            .attr('transform', function (d) { return "translate(" + xScaleDatePosition + ",\n        " + _this.keywordsDistributionValueScale(_this.getValueKeywordDistributionByDate(d, closeDate)) + ")"; });
        mouseLines.select("." + mouseOverLayoutClass + "_mouse-line_value-label")
            .transition()
            .duration(PeriodSelectorComponent.MOUSE_LINE_LABEL_POSITION_DURATION)
            .attr('transform', function () { return ((xScaleWidth / 2) < xScaleDatePosition)
            ? "translate(" + (-PeriodSelectorComponent.MOUSE_LINE_VALUE_LABEL_WIDTH - 5) + ",\n            " + (-PeriodSelectorComponent.MOUSE_LINE_LABEL_HEIGHT - 5) + ")"
            : "translate(5," + (-PeriodSelectorComponent.MOUSE_LINE_LABEL_HEIGHT - 5) + ")"; });
        mouseLines.select('text')
            .text(function (d) { return _this.getValueKeywordDistributionByDate(d, closeDate)
            .toLocaleString(undefined, { maximumFractionDigits: 0 }); });
    };
    PeriodSelectorComponent.prototype.getValueKeywordDistributionByDate = function (keyword, dateToSearch) {
        return this.getKeywordValueOfDistribution(keyword.distribution
            .find(function (distribution) { return distribution.datetime.getTime() === dateToSearch.getTime(); }));
    };
    PeriodSelectorComponent.componentMinHeightExpanded = 200;
    PeriodSelectorComponent.componentHeightCollapsed = 90;
    PeriodSelectorComponent.MOUSE_LINE_LABEL_POSITION_DURATION = 100;
    PeriodSelectorComponent.MOUSE_LINE_DATE_LABEL_WIDTH = 115;
    PeriodSelectorComponent.MOUSE_LINE_VALUE_LABEL_WIDTH = 80;
    PeriodSelectorComponent.MOUSE_LINE_LABEL_HEIGHT = 30;
    return PeriodSelectorComponent;
}());
exports.PeriodSelectorComponent = PeriodSelectorComponent;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(294);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(14)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/resolve-url-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?sourceMap!./period-selector.component.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/resolve-url-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?sourceMap!./period-selector.component.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(112);
exports = module.exports = __webpack_require__(13)(false);
// imports


// module
exports.push([module.i, ".period-selector__seasons-list {\n  display: block;\n  width: 100%;\n}\n\n.period-selector__seasons-list .seasons-serie {\n  cursor: pointer;\n}\n\n.period-selector__seasons-list .seasons-serie__header,\n.period-selector__seasons-list .seasons-serie__distribution-area,\n.period-selector__seasons-list .seasons-serie__distribution-line {\n  opacity: 0.8;\n  transition-property: fill, opacity;\n  transition-duration: 0.3s;\n}\n\n.period-selector__seasons-list .seasons-serie__icon {\n  height: 100%;\n  background-position: 50%;\n  background-size: cover;\n}\n\n.period-selector__seasons-list .seasons-serie__distribution-area {\n  fill: transparent;\n}\n\n.period-selector__seasons-list .seasons-serie__distribution-area--selected-keyword-1 {\n  fill: #eab95c;\n}\n\n.period-selector__seasons-list .seasons-serie__distribution-area--selected-keyword-2 {\n  fill: rgba(137, 185, 193, 0.2);\n}\n\n.period-selector__seasons-list .seasons-serie__distribution-area--selected-keyword-2.seasons-serie__distribution-area--filled {\n  fill: #89b9c1;\n}\n\n.period-selector__seasons-list .seasons-serie__distribution-line {\n  fill: transparent;\n  stroke-width: 2px;\n}\n\n.period-selector__seasons-list .seasons-serie__distribution-line--selected-keyword-1 {\n  stroke: #eab95c;\n}\n\n.period-selector__seasons-list .seasons-serie__distribution-line--selected-keyword-2 {\n  stroke: #89b9c1;\n}\n\n.period-selector__seasons-list .seasons-serie__distribution-ground {\n  fill: rgba(129, 132, 139, 0.25);\n}\n\n.period-selector__seasons-list .seasons-serie__preview-background {\n  height: 100%;\n  background-position: 50%;\n  background-size: cover;\n}\n\n.period-selector__seasons-list .seasons-serie__preview-bubble {\n  fill: white;\n  opacity: 0.7;\n  transition-property: fill, opacity;\n  transition-duration: 0.3s;\n}\n\n.period-selector__seasons-list .seasons-serie__preview-text {\n  fill: #81848b;\n  font-size: 16px;\n  text-anchor: middle;\n  transition-property: fill;\n  transition-duration: 0.3s;\n}\n\n.period-selector__seasons-list .seasons-serie--winter .seasons-serie__header {\n  fill: #71c2f0;\n}\n\n.period-selector__seasons-list .seasons-serie--winter .seasons-serie__icon {\n  background-image: url(" + escape(__webpack_require__(295)) + ");\n}\n\n.period-selector__seasons-list .seasons-serie--winter .seasons-serie__preview-background {\n  background-image: url(https://assets.empathybroker.com/resources/insights/catalog/seasonalkeywords/assets/images/seasons/winter.png);\n}\n\n.period-selector__seasons-list .seasons-serie--spring .seasons-serie__header {\n  fill: #d8d65f;\n}\n\n.period-selector__seasons-list .seasons-serie--spring .seasons-serie__icon {\n  background-image: url(" + escape(__webpack_require__(296)) + ");\n}\n\n.period-selector__seasons-list .seasons-serie--spring .seasons-serie__preview-background {\n  background-image: url(https://assets.empathybroker.com/resources/insights/catalog/seasonalkeywords/assets/images/seasons/spring.png);\n}\n\n.period-selector__seasons-list .seasons-serie--summer .seasons-serie__header {\n  fill: #eace60;\n}\n\n.period-selector__seasons-list .seasons-serie--summer .seasons-serie__icon {\n  background-image: url(" + escape(__webpack_require__(297)) + ");\n}\n\n.period-selector__seasons-list .seasons-serie--summer .seasons-serie__preview-background {\n  background-image: url(https://assets.empathybroker.com/resources/insights/catalog/seasonalkeywords/assets/images/seasons/summer.png);\n}\n\n.period-selector__seasons-list .seasons-serie--autumn .seasons-serie__header {\n  fill: #edc071;\n}\n\n.period-selector__seasons-list .seasons-serie--autumn .seasons-serie__icon {\n  background-image: url(" + escape(__webpack_require__(298)) + ");\n}\n\n.period-selector__seasons-list .seasons-serie--autumn .seasons-serie__preview-background {\n  background-image: url(https://assets.empathybroker.com/resources/insights/catalog/seasonalkeywords/assets/images/seasons/autumn.png);\n}\n\n.period-selector__seasons-list .seasons-serie--selected .seasons-serie__header,\n.period-selector__seasons-list .seasons-serie--selected .seasons-serie__distribution-area,\n.period-selector__seasons-list .seasons-serie--selected .seasons-serie__distribution-line {\n  opacity: 1;\n}\n\n.period-selector__seasons-list .seasons-serie--selected .seasons-serie__preview-bubble {\n  opacity: 0.8;\n}\n\n.period-selector__seasons-list .seasons-serie--selected .seasons-serie__preview-text {\n  fill: white;\n}\n\n.period-selector__seasons-list .seasons-serie--selected.seasons-serie--winter .seasons-serie__preview-bubble {\n  fill: #71c2f0;\n}\n\n.period-selector__seasons-list .seasons-serie--selected.seasons-serie--spring .seasons-serie__preview-bubble {\n  fill: #d8d65f;\n}\n\n.period-selector__seasons-list .seasons-serie--selected.seasons-serie--summer .seasons-serie__preview-bubble {\n  fill: #eace60;\n}\n\n.period-selector__seasons-list .seasons-serie--selected.seasons-serie--autumn .seasons-serie__preview-bubble {\n  fill: #edc071;\n}\n\n.period-selector__seasons-list .seasons-serie--not-selected .seasons-serie__header,\n.period-selector__seasons-list .seasons-serie--not-selected .seasons-serie__distribution-area,\n.period-selector__seasons-list .seasons-serie--not-selected .seasons-serie__distribution-line {\n  opacity: 0.6;\n}\n\n.period-selector__seasons-list .seasons-serie--hovered .seasons-serie__header,\n.period-selector__seasons-list .seasons-serie--hovered .seasons-serie__distribution-area,\n.period-selector__seasons-list .seasons-serie--hovered .seasons-serie__distribution-line {\n  opacity: 1;\n}\n\n.period-selector__seasons-list .seasons-serie--hovered .seasons-serie__preview-bubble {\n  opacity: 0.9;\n}\n\n.period-selector__seasons-list .seasons-serie__mouse-over-layout_vertical-line {\n  stroke: #81848b;\n  stroke-width: 2px;\n}\n\n.period-selector__seasons-list .seasons-serie__mouse-over-layout_date-label rect {\n  fill: #81848b;\n}\n\n.period-selector__seasons-list .seasons-serie__mouse-over-layout_date-label text {\n  text-anchor: middle;\n  font-size: 16px;\n  fill: white;\n}\n\n.period-selector__seasons-list .seasons-serie__mouse-over-layout_mouse-line_circle-label {\n  stroke-width: 5px;\n  fill: white;\n}\n\n.period-selector__seasons-list .seasons-serie__mouse-over-layout_mouse-line_circle-label-1 {\n  stroke: #eab95c;\n}\n\n.period-selector__seasons-list .seasons-serie__mouse-over-layout_mouse-line_circle-label-2 {\n  stroke: #89b9c1;\n}\n\n.period-selector__seasons-list .seasons-serie__mouse-over-layout_mouse-line_value-label {\n  stroke-width: 3px;\n}\n\n.period-selector__seasons-list .seasons-serie__mouse-over-layout_mouse-line_value-label-1 {\n  stroke: #eab95c;\n}\n\n.period-selector__seasons-list .seasons-serie__mouse-over-layout_mouse-line_value-label-2 {\n  stroke: #89b9c1;\n}\n\n.period-selector__seasons-list .seasons-serie__mouse-over-layout_mouse-line_value-label-1 {\n  fill: #f6e0b6;\n}\n\n.period-selector__seasons-list .seasons-serie__mouse-over-layout_mouse-line_value-label-2 {\n  fill: #cce1e4;\n}\n\n.period-selector__seasons-list .seasons-serie__mouse-over-layout_mouse-line_value-label text {\n  text-anchor: middle;\n  font-size: 16px;\n  fill: #81848b;\n}\n\n.period-selector__seasons-list .seasons-serie__mouse-over-layout_mouse-container {\n  pointer-events: all;\n  fill: none;\n}", ""]);

// exports


/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(300);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(14)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/resolve-url-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?sourceMap!./selected-keywords-container.component.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/resolve-url-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?sourceMap!./selected-keywords-container.component.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(13)(false);
// imports


// module
exports.push([module.i, ".selected-keywords-container__period-selector,\n.selected-keywords-container__keywords-details {\n  position: relative;\n}\n\n.selected-keywords-container__expander-control {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  background-color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #c3c5c8;\n  border-radius: 50%;\n  box-sizing: border-box;\n  color: #81848b;\n  cursor: pointer;\n  font-size: 20px;\n  line-height: 35px;\n  text-align: center;\n  width: 37px;\n  height: 37px;\n  transition-duration: 0.3s;\n}\n\n@media (hover: hover) {\n  .selected-keywords-container__expander-control {\n    background-color: rgba(255, 255, 255, 0.5);\n    border-color: #dedfe1;\n    color: #b6b8bc;\n    transition-property: background-color, border-color, color;\n  }\n\n  .selected-keywords-container__expander-control:hover,\n  .selected-keywords-container__expander-control:active,\n  .selected-keywords-container__expander-control:focus {\n    background-color: rgba(255, 255, 255, 0.9);\n    border-color: #c3c5c8;\n    color: #81848b;\n  }\n}\n\n.selected-keywords-container__expander-control--expand:before {\n  content: '+';\n}\n\n.selected-keywords-container__expander-control--collapse:before {\n  content: '-';\n}", ""]);

// exports


/***/ })
/******/ ])});;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@empathybroker/seasonal-keywords/dist/visualization.js
// module id = Bocb
// module chunks = 7